/* AUTO-GENERATED - COMPILED FROM TYPESCRIPT, DO NOT EDIT DIRECTLY */
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _variants, _selectedVariantId, _displayModeInstance, _ZygVariantPicker_instances, buildContext_fn, parseVariantsData_fn, initializeSelectedVariant_fn, bindEvents_fn, unbindEvents_fn, doSelectVariant_fn, navigateGallery_fn, updateSelectedState_fn, emitVariantChange_fn, updateUrl_fn, trackView_fn, trackSelect_fn;
const RADIX_DECIMAL$1 = 10;
const CENTS_DIVISOR = 100;
const DECIMAL_PLACES = 2;
const FALLBACK_MONEY_PREFIX = "$";
const PERCENTAGE_MULTIPLIER = 100;
const DEFAULT_QUANTITY$1 = 1;
const FREE_GIFT_LABEL = "FREE";
const ADDED_FEEDBACK_DURATION = 2e3;
const DISPLAY_NONE = "none";
const WINDOW_TARGET_BLANK = "_blank";
const WINDOW_FEATURES_SECURE = "noopener,noreferrer";
const INTL_STYLE_CURRENCY = "currency";
const INTL_CURRENCY_DISPLAY_NARROW = "narrowSymbol";
const DEFAULT_CURRENCY = "USD";
const CHECKOUT_URL$1 = "/checkout";
const EVENT_CHANGE = "change";
const EVENT_CLICK = "click";
const ATTR_ACTION$1 = "data-action";
const ATTR_VARIANT_ID = "data-variant-id";
const ATTR_PRODUCT_ID = "data-product-id";
const ATTR_SELLING_PLAN = "data-selling-plan";
const ATTR_QUANTITY = "data-quantity";
const ATTR_AVAILABLE = "data-available";
const ATTR_CART_FEEDBACK = "data-cart-feedback";
const ATTR_PRICE = "data-price";
const ATTR_COMPARE_PRICE = "data-compare-price";
const PROPERTY_SUBSCRIPTION = "_subscription";
const PROPERTY_LINE_ITEM_ID = "_line_item_id";
const PROPERTY_PARENT_LINE_ITEM_ID = "_parent_line_item_id";
const PROPERTY_UPSELL = "_upsell";
const PROPERTY_SOURCE = "_source";
const PROPERTY_INITIAL_OFFER = "_initial_offer";
const SOURCE_CTA_BUTTON = "cta-button";
const SOURCE_OFFER_PICKER = "offer-picker";
const SOURCE_UPSELL = "upsell";
const SOURCE_COMPLEMENTARY = "complementary";
const OFFER_TYPE = {
  SUBSCRIPTION: "subscription",
  ONE_TIME: "otp"
};
const PLACEHOLDER_COUNT = "{count}";
class CallToActionEvent {
  /** Builds the detail object for DOM CustomEvents */
  buildEventDetail(context) {
    return {
      action: this.type,
      variantId: context.variantId,
      productId: context.productId,
      quantity: context.quantity,
      sellingPlanId: context.sellingPlanId
    };
  }
}
const ERROR_UNKNOWN = "Unknown error";
class CartActionBase extends CallToActionEvent {
  constructor() {
    super(...arguments);
    this.domEvent = "zyg:cta:add-to-cart:success";
    this.domEventError = "zyg:cta:add-to-cart:error";
    this.analyticsAction = "cta_add_to_cart";
    this.analyticsActionError = "cta_add_to_cart_error";
    this.requiresAvailability = true;
    this.errorMissingVariant = "[cta] Missing variant ID for add to cart";
    this.errorCartNotAvailable = "[cta] Cart not available";
    this.errorAddFailed = "[cta] Failed to add to cart:";
  }
  validate(context) {
    if (!context.variantId) {
      return { valid: false, error: this.errorMissingVariant };
    }
    return { valid: true };
  }
  /** Reports cart add error - shared by all cart actions */
  reportError(context, host, error) {
    const errorMessage = error instanceof Error ? error.message : ERROR_UNKNOWN;
    console.error(`${this.errorAddFailed} ${errorMessage}`);
    const detail = { ...this.buildEventDetail(context), error: errorMessage };
    host.emitError(this.domEventError, this.analyticsActionError, detail);
  }
}
class AddToCartAction extends CartActionBase {
  constructor() {
    super(...arguments);
    this.type = "add-to-cart";
  }
  async execute(context, host) {
    host.setLoading(true);
    try {
      await host.executeCartAdd(context);
      const detail = this.buildEventDetail(context);
      host.emitAndTrack(this.domEvent, this.analyticsAction, { ...detail, success: true });
      host.showAddedFeedback();
    } catch (error) {
      this.reportError(context, host, error);
    } finally {
      host.setLoading(false);
    }
  }
}
class NavigateAction extends CallToActionEvent {
  constructor() {
    super(...arguments);
    this.type = "go-to-page";
    this.domEvent = "zyg:cta:navigate";
    this.analyticsAction = "cta_navigate";
    this.requiresAvailability = false;
    this.errorMissingUrl = "[cta] Missing link URL for navigation";
  }
  validate(context) {
    if (!context.linkUrl) {
      return { valid: false, error: this.errorMissingUrl };
    }
    return { valid: true };
  }
  buildEventDetail(context) {
    return { url: context.linkUrl, newTab: context.openNewTab };
  }
  execute(context, host) {
    if (!context.linkUrl) {
      return;
    }
    const detail = this.buildEventDetail(context);
    host.emitAndTrack(this.domEvent, this.analyticsAction, detail);
    if (context.openNewTab) {
      window.open(context.linkUrl, WINDOW_TARGET_BLANK, WINDOW_FEATURES_SECURE);
      return;
    }
    window.location.href = context.linkUrl;
  }
}
const byteToHex = [];
for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 256).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    if (typeof crypto === "undefined" || !crypto.getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    getRandomValues = crypto.getRandomValues.bind(crypto);
  }
  return getRandomValues(rnds8);
}
const randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const native = { randomUUID };
function v4(options, buf, offset) {
  if (native.randomUUID && true && !options) {
    return native.randomUUID();
  }
  options = options || {};
  const rnds = options.random ?? options.rng?.() ?? rng();
  if (rnds.length < 16) {
    throw new Error("Random bytes length must be >= 16");
  }
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  return unsafeStringify(rnds);
}
const generateId = () => {
  return v4();
};
const isDefined = (value) => value != null;
function isHTMLElementLike(element) {
  if (element == null) {
    return false;
  }
  if (element instanceof HTMLElement) {
    return true;
  }
  return typeof element === "object" && ("textContent" in element || "style" in element || "dataset" in element || "classList" in element);
}
function hide(element) {
  if (isHTMLElementLike(element) && element.style) {
    element.style.setProperty("display", "none");
  }
}
function show(element) {
  if (isHTMLElementLike(element) && element.style) {
    element.style.removeProperty("display");
  }
}
function mergeConfigOverrides(base, override) {
  const merged = { ...base };
  Object.entries(override).forEach(([key, value]) => {
    if (value) {
      merged[key] = value;
    }
  });
  return merged;
}
async function raceWithTimeout(promise, timeoutMs) {
  return Promise.race([
    promise.catch(() => void 0),
    new Promise((resolve) => setTimeout(resolve, timeoutMs))
  ]);
}
const CART_LOGIC_GLOBAL_KEY = "__zygCartLogic";
const CART_LOGIC_TIMEOUT_MS = 5e3;
async function waitForCartLogic() {
  const globalState = window[CART_LOGIC_GLOBAL_KEY];
  if (!globalState?.evaluationPromise) {
    return;
  }
  await raceWithTimeout(globalState.evaluationPromise, CART_LOGIC_TIMEOUT_MS);
}
const STRAIGHT_TO_CHECKOUT_OPTIONS = { skipDrawer: true, clearFirst: true };
class StraightToCheckoutAction extends CartActionBase {
  constructor() {
    super(...arguments);
    this.type = "straight-to-checkout";
  }
  buildEventDetail(context) {
    return { ...super.buildEventDetail(context), checkout: true, replaced: true };
  }
  async execute(context, host) {
    host.setLoading(true);
    try {
      await host.executeCartAdd(context, STRAIGHT_TO_CHECKOUT_OPTIONS);
      await waitForCartLogic();
      const detail = this.buildEventDetail(context);
      host.emitAndTrack(this.domEvent, this.analyticsAction, { ...detail, success: true });
      window.location.href = CHECKOUT_URL$1;
    } catch (error) {
      this.reportError(context, host, error);
      host.setLoading(false);
    }
  }
}
const EASE_FACTOR = 0.12;
const ARRIVAL_TOLERANCE_PX = 2;
const MIN_STEP_PX = 1;
const MAX_SCROLL_DURATION_MS = 3e3;
let activeScrollRafId = null;
function scrollToElement(element) {
  if (activeScrollRafId !== null) {
    window.cancelAnimationFrame(activeScrollRafId);
    activeScrollRafId = null;
  }
  const startTime = performance.now();
  function step() {
    if (!element.isConnected) {
      activeScrollRafId = null;
      return;
    }
    const rect = element.getBoundingClientRect();
    const offset = rect.top;
    if (Math.abs(offset) <= ARRIVAL_TOLERANCE_PX || performance.now() - startTime > MAX_SCROLL_DURATION_MS) {
      activeScrollRafId = null;
      return;
    }
    const scrollYBefore = window.scrollY;
    const raw = offset * EASE_FACTOR;
    const px = Math.abs(raw) < MIN_STEP_PX ? Math.sign(raw) * MIN_STEP_PX : Math.round(raw);
    window.scrollBy(0, px);
    if (window.scrollY === scrollYBefore) {
      activeScrollRafId = null;
      return;
    }
    activeScrollRafId = requestAnimationFrame(step);
  }
  activeScrollRafId = requestAnimationFrame(step);
}
const SHOP_SECTION_SELECTOR = '[id*="zyg-shop-section"], [id*="zyg_shop_section"]';
function findShopSection() {
  return document.querySelector(SHOP_SECTION_SELECTOR);
}
class ScrollToAction extends CallToActionEvent {
  constructor() {
    super(...arguments);
    this.type = "scroll-to";
    this.domEvent = "zyg:cta:scroll";
    this.analyticsAction = "cta_scroll";
    this.requiresAvailability = false;
    this.errorMissingTarget = "[cta] Missing scroll target";
    this.errorInvalidSelector = "[cta] Invalid scroll target selector:";
    this.errorTargetNotFound = "[cta] Scroll target not found:";
  }
  validate(context) {
    if (!context.scrollTarget) {
      return { valid: false, error: this.errorMissingTarget };
    }
    return { valid: true };
  }
  buildEventDetail(context) {
    return { target: context.scrollTarget };
  }
  execute(context, host) {
    if (!context.scrollTarget) {
      return;
    }
    let element;
    try {
      element = document.querySelector(context.scrollTarget);
    } catch {
      console.error(this.errorInvalidSelector, context.scrollTarget);
      return;
    }
    if (!element) {
      console.error(this.errorTargetNotFound, context.scrollTarget);
      return;
    }
    const detail = this.buildEventDetail(context);
    host.emitAndTrack(this.domEvent, this.analyticsAction, detail);
    scrollToElement(element);
  }
}
class ScrollToShopAction extends CallToActionEvent {
  constructor() {
    super(...arguments);
    this.type = "scroll-to-shop";
    this.domEvent = "zyg:cta:scroll";
    this.analyticsAction = "cta_scroll_to_shop";
    this.requiresAvailability = false;
    this.errorShopSectionNotFound = "[cta] Shop section not found on page";
  }
  validate(_context) {
    return { valid: true };
  }
  buildEventDetail(_context) {
    return { target: SHOP_SECTION_SELECTOR };
  }
  execute(_context, host) {
    const element = findShopSection();
    if (!element) {
      console.error(this.errorShopSectionNotFound);
      return;
    }
    const detail = this.buildEventDetail(_context);
    host.emitAndTrack(this.domEvent, this.analyticsAction, detail);
    scrollToElement(element);
  }
}
const ACTION_ADD_TO_CART$2 = "add-to-cart";
const ACTION_STRAIGHT_TO_CHECKOUT$1 = "straight-to-checkout";
const ACTION_GO_TO_PAGE = "go-to-page";
const ACTION_SCROLL_TO = "scroll-to";
const ACTION_SCROLL_TO_SHOP = "scroll-to-shop";
const ACTION_REGISTRY = {
  [ACTION_ADD_TO_CART$2]: new AddToCartAction(),
  [ACTION_STRAIGHT_TO_CHECKOUT$1]: new StraightToCheckoutAction(),
  [ACTION_GO_TO_PAGE]: new NavigateAction(),
  [ACTION_SCROLL_TO]: new ScrollToAction(),
  [ACTION_SCROLL_TO_SHOP]: new ScrollToShopAction()
};
function getActionEvent(type) {
  return ACTION_REGISTRY[type] ?? ACTION_REGISTRY[ACTION_ADD_TO_CART$2];
}
const ELEMENT_NAME$2 = "zyg-cta-button";
const ANALYTICS_CATEGORY$2 = "cta";
const CLASS_LOADING = "zyg-cta-button--loading";
const CLASS_ADDED = "zyg-cta-button--added";
const CLASS_DISABLED = "zyg-cta-button--disabled";
const ATTR_SCROLL_TARGET = "data-scroll-target";
const ATTR_LINK_URL = "data-link-url";
const ATTR_OPEN_NEW_TAB = "data-open-new-tab";
const ATTR_UNIT_PRICE = "data-unit-price";
const ATTR_UNIT_LABEL = "data-unit-label";
const ATTR_STOCK_QUANTITY = "data-stock-quantity";
const ATTR_STOCK_THRESHOLD = "data-stock-threshold";
const ATTR_STOCK_MODE = "data-stock-mode";
const ATTR_MOCK_STOCK_COUNT = "data-mock-stock-count";
const ATTR_HIDE_COMPARE_PRICE = "data-hide-compare-price";
const ATTR_IS_UPSELL = "data-is-upsell";
const STOCK_MODE_MOCK = "mock";
const SELECTOR_BUTTON = ".zyg-cta-button__btn";
const SELECTOR_PRICE = ".zyg-cta-button__price";
const SELECTOR_COMPARE_PRICE = ".zyg-cta-button__compare-price";
const SELECTOR_UNIT_PRICE = ".zyg-cta-button__unit-price";
const SELECTOR_UNIT_PRICE_VALUE = "[data-unit-price-value]";
const SELECTOR_UNIT_PRICE_LABEL = "[data-unit-price-label]";
const SELECTOR_STOCK_WARNING = ".zyg-cta-button__stock-warning";
const SELECTOR_STOCK_TEXT = "[data-stock-text]";
const UNIT_PRICE_LABEL_PREFIX = "/";
const DEFAULT_NO_STOCK_COUNT = "0";
const DEFAULT_MOCK_STOCK_COUNT = "3";
const DEFAULT_STOCK_TEXT = "Only {count} left";
const VARIANT_INVENTORY_QUANTITY_KEY = "inventory_quantity";
const CLASS_STICKY_VISIBLE = "zyg-cta-button--sticky-visible";
const DOM_EVENT_VARIANT_CHANGE$2 = "zyg:variant:change";
const DOM_EVENT_OFFER_CHANGE$1 = "zyg:offer:change";
const DOM_EVENT_CART_ADD$1 = "cart:add";
const EVENT_SOURCE_PRODUCT_FORM$1 = "product-form-component";
const SELECTOR_OFFER_PICKER = "zyg-offer-picker";
const ATTR_DEFAULT_SELECTION$1 = "data-default-selection";
const OFFER_TYPE_SUBSCRIPTION = "subscription";
const OFFER_TYPE_OTP$1 = "otp";
const ACTION_ADD_TO_CART$1 = "add-to-cart";
const createAsyncQueue = () => {
  let tail = Promise.resolve();
  return {
    enqueue(operation) {
      const result = tail.then(operation, operation);
      tail = result.then(
        () => {
        },
        () => {
        }
      );
      return result;
    }
  };
};
const CART_URL = "/cart.js";
const CART_ADD_URL = "/cart/add.js";
const CART_CHANGE_URL = "/cart/change.js";
const CART_UPDATE_URL = "/cart/update.js";
const CART_CLEAR_URL = "/cart/clear.js";
const EVENT_CART_STATE_CHANGE = "cart:state-change";
const EVENT_CART_CHANGE_LEGACY = "cart:change";
const CART_READY_EVENT = "zyg:cart:ready";
const LOGIC_REWARD_PROPERTY = {
  FREE_GIFT: "_zyg_free",
  FREE_GIFT_LABEL: "_zyg_free_label"
};
const buildComplementaryItem = (id, quantity, parentLineItemId) => ({
  id,
  quantity,
  source: SOURCE_COMPLEMENTARY,
  initialOffer: OFFER_TYPE.ONE_TIME,
  parentLineItemId,
  customProperties: {
    [LOGIC_REWARD_PROPERTY.FREE_GIFT]: "true",
    [LOGIC_REWARD_PROPERTY.FREE_GIFT_LABEL]: FREE_GIFT_LABEL
  }
});
const formatAddItems = (items) => items.map((item) => ({
  id: item.id,
  quantity: item.quantity ?? 1,
  properties: {
    [PROPERTY_LINE_ITEM_ID]: item.lineItemId ?? generateId(),
    [PROPERTY_SOURCE]: item.source,
    [PROPERTY_INITIAL_OFFER]: item.initialOffer ?? (item.sellingPlan ? OFFER_TYPE.SUBSCRIPTION : OFFER_TYPE.ONE_TIME),
    ...item.sellingPlan && { [PROPERTY_SUBSCRIPTION]: "true" },
    ...item.isUpsell && { [PROPERTY_UPSELL]: "true" },
    ...item.parentLineItemId && { [PROPERTY_PARENT_LINE_ITEM_ID]: item.parentLineItemId },
    // customProperties is spread last so callers can intentionally override system properties
    ...item.customProperties
  },
  ...item.sellingPlan && { selling_plan: item.sellingPlan }
}));
const DISCOUNT_URL_TEMPLATE = "/discount/";
const CONTENT_TYPE_JSON = "application/json";
const HTTP_METHOD_GET = "GET";
const HTTP_METHOD_POST = "POST";
const REDIRECT_MANUAL = "manual";
const REDIRECT_TYPE_OPAQUE = "opaqueredirect";
const HTTP_STATUS_REDIRECT = 302;
const ATTR_DISCOUNT_CODE = "discount_code";
const REQUEST_KEY_SECTIONS = "sections";
const isRedirectResponse = (response) => response.type === REDIRECT_TYPE_OPAQUE || response.status === HTTP_STATUS_REDIRECT;
const EVENT_PREPARE_BUNDLED_SECTIONS = "cart:prepare-bundled-sections";
const SOURCE_CART = "cart-singleton";
const CART_READY_TIMEOUT_MS = 5e3;
const ERROR_CART_NOT_READY = "[cart] Cart not available";
class CartError extends Error {
  constructor(response) {
    super(response.message);
    this.name = "CartError";
    this.status = response.status;
    this.description = response.description;
    this.errors = response.errors || {};
  }
}
let state;
let loading = false;
const { enqueue } = createAsyncQueue();
const emit = () => {
  if (!state) {
    return;
  }
  document.dispatchEvent(
    new CustomEvent(EVENT_CART_STATE_CHANGE, {
      bubbles: true,
      detail: { cart: state, source: SOURCE_CART }
    })
  );
  document.dispatchEvent(
    new CustomEvent(EVENT_CART_CHANGE_LEGACY, {
      bubbles: true,
      detail: { cart: state, source: SOURCE_CART, baseEvent: EVENT_CART_CHANGE_LEGACY }
    })
  );
};
const postSilent = async (url, body) => {
  const res = await fetch(url, {
    method: HTTP_METHOD_POST,
    headers: { "Content-Type": CONTENT_TYPE_JSON },
    body: JSON.stringify(body || {})
  });
  const data = await res.json();
  if (data.status) {
    throw new CartError(data);
  }
};
const postSilentWithState = async (url, body) => {
  loading = true;
  try {
    const res = await fetch(url, {
      method: HTTP_METHOD_POST,
      headers: { "Content-Type": CONTENT_TYPE_JSON },
      body: JSON.stringify(body || {})
    });
    const data = await res.json();
    if (data.status) {
      throw new CartError(data);
    }
    state = data;
    return state;
  } finally {
    loading = false;
  }
};
const postAndRefresh = async (url, body) => {
  loading = true;
  try {
    const sectionsToBundle = /* @__PURE__ */ new Set();
    document.documentElement.dispatchEvent(
      new CustomEvent(EVENT_PREPARE_BUNDLED_SECTIONS, {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );
    const requestBody = body || {};
    if (sectionsToBundle.size > 0) {
      requestBody[REQUEST_KEY_SECTIONS] = [...sectionsToBundle].join(",");
    }
    const res = await fetch(url, {
      method: HTTP_METHOD_POST,
      headers: { "Content-Type": CONTENT_TYPE_JSON },
      body: JSON.stringify(requestBody)
    });
    const data = await res.json();
    if (data.status) {
      throw new CartError(data);
    }
    if (url === CART_ADD_URL) {
      const cartRes = await fetch(CART_URL);
      state = await cartRes.json();
    } else {
      state = data;
    }
    emit();
    return state;
  } finally {
    loading = false;
  }
};
const fetchCartState = async (force = false, silent = false) => {
  if (state && !force) {
    return state;
  }
  loading = true;
  try {
    const res = await fetch(CART_URL);
    if (!res.ok) {
      throw new Error(`[cart.fetch] Failed to fetch cart: ${res.status}`);
    }
    state = await res.json();
    if (!silent) {
      emit();
    }
    return state;
  } finally {
    loading = false;
  }
};
const cart = {
  /** Gets the current cart state instance */
  get instance() {
    return state;
  },
  /** Gets the total number of items in the cart */
  get itemCount() {
    return state?.item_count ?? 0;
  },
  /** Gets the current loading status of cart operations */
  get isLoading() {
    return loading;
  },
  /**
   * Fetches cart state from Shopify's `/cart.js` endpoint.
   *
   * By default, returns the cached cart state if available. Pass `force=true` to
   * bypass the cache and fetch fresh data from the server (useful after external
   * cart modifications or to ensure data freshness).
   *
   * On successful fetch, updates internal state and emits a `cart:state-change`
   * event to notify subscribers of the new cart data.
   *
   * Note: Unlike cart mutation endpoints (/cart/change.js, /cart/add.js),
   * the /cart.js endpoint does NOT support section bundling.
   *
   * @param force - When true, bypasses cache and fetches from server. Default: false.
   * @param silent - When true, skips emitting cart:state-change event. Default: false.
   * @returns The current cart state.
   * @throws Error if the fetch request fails (non-2xx response).
   */
  async fetch(force = false, silent = false) {
    return enqueue(() => fetchCartState(force, silent));
  },
  /**
   * Adds a single item to cart. Throws CartError on failure.
   *
   * @param item - CartAddItem describing the item and its cart properties.
   * @returns The updated cart state.
   */
  async add(item) {
    if (!item.id) {
      throw new Error("[cart.add] Missing variant id");
    }
    return enqueue(() => postAndRefresh(CART_ADD_URL, formatAddItems([item])[0]));
  },
  /**
   * Adds multiple items to cart in a single API call.
   *
   * @param items - Array of items to add.
   * @returns The updated cart state.
   */
  async addMultiple(items) {
    if (items.length === 0) {
      return this.instance;
    }
    return enqueue(() => postAndRefresh(CART_ADD_URL, { items: formatAddItems(items) }));
  },
  /**
   * Adds a primary item to cart with an optional linked complementary gift in a single API call.
   * Generates a shared lineItemId to link the parent and gift so removeWithComplementary
   * can remove both when the parent is removed.
   *
   * @param parentItem - The primary item to add.
   * @param complementaryVariantId - Optional variant ID of the complementary gift.
   * @param complementaryQty - Quantity of the complementary gift.
   * @returns The updated cart state.
   */
  async addWithComplementary(parentItem, complementaryVariantId, complementaryQty) {
    if (!complementaryVariantId) {
      return this.addMultiple([parentItem]);
    }
    const lineItemId = parentItem.lineItemId ?? generateId();
    return this.addMultiple([
      { ...parentItem, lineItemId },
      buildComplementaryItem(complementaryVariantId, complementaryQty ?? 1, lineItemId)
    ]);
  },
  /**
   * Updates quantity for a cart item by key.
   *
   * @param key - Unique item key to update.
   * @param quantity - New quantity value.
   * @returns The updated cart state.
   */
  async update(key, quantity) {
    if (!key) {
      throw new Error("[cart.update] Missing item key");
    }
    return enqueue(() => postAndRefresh(CART_CHANGE_URL, { id: key, quantity }));
  },
  /**
   * Removes a cart item by key.
   *
   * @param key - Unique item key to remove.
   * @returns The updated cart state.
   */
  async remove(key) {
    return this.update(key, 0);
  },
  /**
   * Removes a cart item by key without emitting state change events.
   * Use this for batch operations, then call emitStateChange() when done.
   *
   * @param key - Unique item key to remove.
   * @returns The updated cart state.
   */
  async removeSilent(key) {
    if (!key) {
      throw new Error("[cart.removeSilent] Missing item key");
    }
    return enqueue(() => postSilentWithState(CART_CHANGE_URL, { id: key, quantity: 0 }));
  },
  /**
   * Removes multiple cart items by key in a single API call.
   *
   * @param keys - Array of unique item keys to remove.
   * @returns The updated cart state.
   */
  async removeMultiple(keys) {
    if (keys.length === 0) {
      return this.instance;
    }
    const updates = keys.reduce(
      (acc, key) => {
        acc[key] = 0;
        return acc;
      },
      {}
    );
    return enqueue(() => postAndRefresh(CART_UPDATE_URL, { updates }));
  },
  /**
   * Removes multiple cart items silently without emitting state change events.
   * Uses /cart/update.js for batched removal in a single API call.
   *
   * @param keys - Array of unique item keys to remove.
   * @returns The updated cart state.
   */
  async removeMultipleSilent(keys) {
    if (keys.length === 0) {
      return this.instance;
    }
    const updates = keys.reduce(
      (acc, key) => {
        acc[key] = 0;
        return acc;
      },
      {}
    );
    return enqueue(() => postSilentWithState(CART_UPDATE_URL, { updates }));
  },
  /**
   * Updates properties for a cart item by key. Preserves quantity.
   *
   * @param key - Unique item key to update.
   * @param properties - New properties to merge with existing ones.
   * @returns The updated cart state.
   */
  async updateProperties(key, properties) {
    if (!key) {
      throw new Error("[cart.updateProperties] Missing item key");
    }
    return enqueue(async () => {
      const currentCart = await fetchCartState(true, true);
      const currentItem = currentCart.items.find((item) => item.key === key);
      if (!currentItem) {
        throw new Error(`[cart.updateProperties] Item with key ${key} not found`);
      }
      return postAndRefresh(CART_CHANGE_URL, {
        id: key,
        quantity: currentItem.quantity,
        properties: { ...currentItem.properties ?? {}, ...properties }
      });
    });
  },
  /**
   * Removes all items from cart.
   *
   * @returns The empty cart state.
   */
  async clear() {
    return enqueue(() => postAndRefresh(CART_CLEAR_URL));
  },
  /**
   * Forces a fresh fetch from Shopify API.
   *
   * @returns The fresh cart state.
   */
  async refresh() {
    return this.fetch(true);
  },
  /**
   * Updates cart note.
   *
   * @param note - The new note content.
   * @returns The updated cart state.
   */
  async updateNote(note) {
    return enqueue(() => postAndRefresh(CART_UPDATE_URL, { note }));
  },
  /**
   * Updates cart attributes.
   *
   * @param attributes - Map of attribute keys and values to update.
   * @returns The updated cart state.
   */
  async updateAttributes(attributes) {
    return enqueue(() => postAndRefresh(CART_UPDATE_URL, { attributes }));
  },
  /**
   * Applies or removes a discount code on the cart.
   * Pass empty string to remove current discount.
   *
   * @param code - The discount code to apply.
   * @returns The updated cart state.
   */
  async setDiscount(code) {
    return enqueue(() => postAndRefresh(CART_UPDATE_URL, { discount: code }));
  },
  /**
   * Adds multiple items silently without emitting state change events.
   * Use this for batch operations, then call emitStateChange() when done.
   *
   * @param items - Array of items to add.
   * @returns The updated cart state.
   */
  async addMultipleSilent(items) {
    if (items.length === 0) {
      return this.instance;
    }
    return enqueue(async () => {
      await postSilent(CART_ADD_URL, { items: formatAddItems(items) });
      return fetchCartState(true, true);
    });
  },
  /**
   * Applies discount code silently without emitting state change events.
   * Use this for batch operations, then call emitStateChange() when done.
   *
   * @param code - The discount code to apply.
   * @returns The updated cart state.
   */
  async setDiscountSilent(code) {
    return enqueue(() => postSilentWithState(CART_UPDATE_URL, { discount: code }));
  },
  /**
   * Emits cart state change event manually.
   * Call this after silent operations to notify other components.
   */
  emitStateChange() {
    emit();
  },
  /**
   * Switches a cart item between subscription and one-time purchase.
   *
   * Shopify doesn't allow modifying the selling plan of an item already in cart,
   * so this method removes the item and re-adds it with or without the selling plan.
   * Optimized: Uses silent operations and single final fetch for speed.
   *
   * @param key - The unique key of the item to switch.
   * @param variantId - The variant ID of the item.
   * @param sellingPlanId - The new selling plan ID (optional for one-time purchase).
   * @param options - Optional item data to skip initial fetch (faster).
   * @returns The updated cart state.
   */
  async switchSubscription(key, variantId, sellingPlanId, options) {
    if (!key) {
      throw new Error("[cart.switchSubscription] Missing item key");
    }
    if (!variantId) {
      throw new Error("[cart.switchSubscription] Missing variant ID");
    }
    return enqueue(async () => {
      let quantity;
      let properties;
      if (options) {
        quantity = options.quantity;
        properties = options.properties ?? {};
      } else {
        let currentItem = state?.items.find((item) => item.key === key);
        if (!currentItem) {
          const currentCart = await fetchCartState(true, true);
          currentItem = currentCart.items.find((item) => item.key === key);
          if (!currentItem) {
            throw new Error(`[cart.switchSubscription] Item with key ${key} not found`);
          }
        }
        quantity = currentItem.quantity;
        properties = currentItem.properties ?? {};
      }
      const preservedProperties = Object.fromEntries(
        Object.entries(properties).filter(
          ([propKey]) => !propKey.startsWith(PROPERTY_SUBSCRIPTION)
        )
      );
      if (sellingPlanId) {
        preservedProperties[PROPERTY_SUBSCRIPTION] = "true";
      }
      if (!preservedProperties[PROPERTY_LINE_ITEM_ID]) {
        preservedProperties[PROPERTY_LINE_ITEM_ID] = generateId();
      }
      loading = true;
      await postSilent(CART_CHANGE_URL, { id: key, quantity: 0 });
      await postSilent(CART_ADD_URL, {
        id: variantId,
        quantity,
        properties: preservedProperties,
        ...sellingPlanId && { selling_plan: sellingPlanId }
      });
      return fetchCartState(true, false);
    });
  },
  /**
   * Checks if a discount code is valid by attempting to apply it.
   * Returns true if the code appears valid (redirect or cart discount).
   * Note: This is a heuristic check - actual validity is determined at checkout.
   *
   * @param code - The discount code to check.
   * @returns True if the code is potentially valid.
   */
  async checkDiscountValid(code) {
    return enqueue(async () => {
      try {
        const response = await fetch(
          `${DISCOUNT_URL_TEMPLATE}${encodeURIComponent(code)}`,
          {
            method: HTTP_METHOD_GET,
            redirect: REDIRECT_MANUAL
          }
        );
        if (isRedirectResponse(response)) {
          return true;
        }
        const freshCart = await fetchCartState(true, false);
        if (freshCart.total_discount > 0) {
          return true;
        }
        const attrResponse = await fetch(CART_UPDATE_URL, {
          method: HTTP_METHOD_POST,
          headers: { "Content-Type": CONTENT_TYPE_JSON },
          body: JSON.stringify({ attributes: { [ATTR_DISCOUNT_CODE]: code } })
        });
        return attrResponse.ok;
      } catch (error) {
        console.error(
          "[cart.checkDiscountValid] Error checking discount validity:",
          error instanceof Error ? error.message : String(error)
        );
        return true;
      }
    });
  }
};
window.cart = cart;
document.dispatchEvent(new CustomEvent(CART_READY_EVENT));
const whenCartReady = (timeoutMs = CART_READY_TIMEOUT_MS) => new Promise((resolve, reject) => {
  if (window.cart) {
    resolve(window.cart);
    return;
  }
  const timeoutId = setTimeout(() => {
    document.removeEventListener(CART_READY_EVENT, onReady);
    reject(new Error(ERROR_CART_NOT_READY));
  }, timeoutMs);
  const onReady = () => {
    clearTimeout(timeoutId);
    document.removeEventListener(CART_READY_EVENT, onReady);
    if (window.cart) {
      resolve(window.cart);
    } else {
      reject(new Error(ERROR_CART_NOT_READY));
    }
  };
  document.addEventListener(CART_READY_EVENT, onReady);
});
const DEFAULT_KEY_ATTR = "data-key";
const DEFAULT_LOADING_CLASS = "is-loading";
const getAttributeFromElement = (element, attr) => {
  if (!element) {
    return void 0;
  }
  const direct = element.getAttribute(attr);
  if (direct) {
    return direct;
  }
  return element.closest(`[${attr}]`)?.getAttribute(attr) ?? void 0;
};
const emitDomEvent = (eventName, detail) => {
  document.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail }));
};
function Actionable(Base, config = {}) {
  const {
    keyAttr = DEFAULT_KEY_ATTR,
    loadingClass = DEFAULT_LOADING_CLASS,
    errorPrefix = "component"
  } = config;
  return class ActionableClass extends Base {
    /** Gets item key from this element's dataset */
    get itemKey() {
      return this.dataset.key;
    }
    /** Finds element by key within this component */
    findByKey(key) {
      return this.querySelector(`[${keyAttr}="${key}"]`);
    }
    /** Queries element by selector within key container */
    queryByKey(selector, key) {
      const container = this.findByKey(key);
      return container?.querySelector(selector) ?? this.querySelector(`${selector}[${keyAttr}="${key}"]`);
    }
    /** Gets key from element or ancestor, falls back to this.itemKey */
    getKeyFromElement(element) {
      if (this.itemKey) {
        return this.itemKey;
      }
      const key = getAttributeFromElement(element, keyAttr);
      if (!key) {
        console.error(`[${errorPrefix}] Item key not found from element`);
      }
      return key;
    }
    /** Emits DOM event and tracks analytics in one call (no API call needed) */
    notify(config2) {
      emitDomEvent(config2.eventName, config2.payload);
      this.track(config2.analyticsAction, config2.payload);
    }
    /** Executes async operation with loading state */
    async executeWithLoading(key, operation, errorMessage) {
      const element = this.findByKey(key);
      element?.classList.add(loadingClass);
      try {
        await operation();
        return true;
      } catch (error) {
        console.error(errorMessage, error);
        return false;
      } finally {
        element?.classList.remove(loadingClass);
      }
    }
    /** Executes action with DOM event, analytics, loading state, and error handling */
    async executeAction(config2) {
      emitDomEvent(config2.domEvent.name, config2.domEvent.detail);
      this.track(config2.analytics.action, config2.analytics.payload);
      try {
        config2.optimisticUpdate?.();
        const success = await this.executeWithLoading(
          config2.itemKey,
          config2.apiCall,
          config2.errorMessage
        );
        if (!success) {
          throw new Error(config2.errorMessage);
        }
        return true;
      } catch (error) {
        console.error(`[${errorPrefix}] ${config2.errorMessage}`, error);
        config2.revertOnFailure?.();
        return false;
      }
    }
  };
}
const STICKY_POSITION_TOP_LEFT = "top-left";
const STICKY_POSITION_TOP_CENTER = "top-center";
const STICKY_POSITION_TOP_RIGHT = "top-right";
const STICKY_POSITION_BOTTOM_RIGHT = "bottom-right";
const STICKY_POSITION_BOTTOM_CENTER = "bottom-center";
const STICKY_POSITION_BOTTOM_LEFT = "bottom-left";
const STICKY_POSITIONS = /* @__PURE__ */ new Set([
  STICKY_POSITION_TOP_LEFT,
  STICKY_POSITION_TOP_CENTER,
  STICKY_POSITION_TOP_RIGHT,
  STICKY_POSITION_BOTTOM_RIGHT,
  STICKY_POSITION_BOTTOM_CENTER,
  STICKY_POSITION_BOTTOM_LEFT
]);
const DEFAULT_STICKY_POSITION = STICKY_POSITION_BOTTOM_RIGHT;
const DEFAULT_STICKY_ATTR = "data-sticky";
const DEFAULT_POSITION_ATTR = "data-sticky-position";
const DEFAULT_OFFSET_X_ATTR = "data-sticky-offset-x";
const DEFAULT_OFFSET_Y_ATTR = "data-sticky-offset-y";
const DEFAULT_START_SECTION_ATTR = "data-sticky-start-section";
const DEFAULT_END_SECTION_ATTR = "data-sticky-end-section";
const DEFAULT_ACTIVE_CLASS = "is-sticky";
const DEFAULT_STICKY_OFFSET = "1.5rem";
const STICKY_Z_INDEX = "9999";
const STICKY_CSS_POSITION = "fixed";
const STICKY_CSS_WIDTH = "auto";
const STICKY_CSS_CENTER_LEFT = "50%";
const STICKY_CSS_CENTER_TRANSFORM = "translateX(-50%)";
const STICKY_DEACTIVATE_DURATION_MS = 200;
const STICKY_DEACTIVATE_TRANSITION = `opacity ${STICKY_DEACTIVATE_DURATION_MS}ms ease`;
const STICKY_DEACTIVATE_OPACITY = "0";
const SENTINEL_TAG = "div";
const SENTINEL_ATTR = "data-sticky-sentinel";
const SENTINEL_SIZE = "1px";
const SENTINEL_POSITION = "absolute";
const SENTINEL_OVERFLOW = "hidden";
const SENTINEL_CLIP = "rect(0 0 0 0)";
const SENTINEL_CLIP_PATH = "inset(50%)";
const SENTINEL_WHITE_SPACE = "nowrap";
const SENTINEL_POINTER_EVENTS = "none";
const POSITION_PREFIX_TOP = "top";
const POSITION_SUFFIX_CENTER = "center";
const POSITION_SUFFIX_LEFT = "left";
function buildStickyStyles(position, offsetX, offsetY) {
  const isTop = position.startsWith(POSITION_PREFIX_TOP);
  const isCenter = position.endsWith(POSITION_SUFFIX_CENTER);
  const styles = {
    top: isTop ? offsetY : "",
    bottom: isTop ? "" : offsetY,
    left: "",
    right: "",
    width: STICKY_CSS_WIDTH,
    transform: ""
  };
  if (isCenter) {
    styles.left = STICKY_CSS_CENTER_LEFT;
    styles.transform = STICKY_CSS_CENTER_TRANSFORM;
  } else if (position.endsWith(POSITION_SUFFIX_LEFT)) {
    styles.left = offsetX;
  } else {
    styles.right = offsetX;
  }
  return styles;
}
function createSentinel() {
  const sentinel = document.createElement(SENTINEL_TAG);
  sentinel.setAttribute(SENTINEL_ATTR, "");
  sentinel.style.height = SENTINEL_SIZE;
  sentinel.style.width = SENTINEL_SIZE;
  sentinel.style.position = SENTINEL_POSITION;
  sentinel.style.overflow = SENTINEL_OVERFLOW;
  sentinel.style.clip = SENTINEL_CLIP;
  sentinel.style.clipPath = SENTINEL_CLIP_PATH;
  sentinel.style.whiteSpace = SENTINEL_WHITE_SPACE;
  sentinel.style.pointerEvents = SENTINEL_POINTER_EVENTS;
  return sentinel;
}
function isBoundaryAboveViewport(entry) {
  return entry.boundingClientRect.bottom < 0;
}
const SHOPIFY_SECTION_ID_PREFIX = "#shopify-section-";
function findSectionElement(selector) {
  if (!selector) {
    return null;
  }
  const exact = document.querySelector(selector);
  if (exact) {
    return exact;
  }
  if (!selector.startsWith(SHOPIFY_SECTION_ID_PREFIX)) {
    return null;
  }
  return document.querySelector(
    `[id$="__${CSS.escape(selector.slice(SHOPIFY_SECTION_ID_PREFIX.length))}"]`
  );
}
function Stickable(Base, config = {}) {
  const {
    stickyAttr = DEFAULT_STICKY_ATTR,
    positionAttr = DEFAULT_POSITION_ATTR,
    offsetXAttr = DEFAULT_OFFSET_X_ATTR,
    offsetYAttr = DEFAULT_OFFSET_Y_ATTR,
    startSectionAttr = DEFAULT_START_SECTION_ATTR,
    endSectionAttr = DEFAULT_END_SECTION_ATTR,
    activeClass = DEFAULT_ACTIVE_CLASS
  } = config;
  return class StickableClass extends Base {
    #stickyObserver = null;
    #stickySentinel = null;
    #deactivateTimer = null;
    #stickyActive = false;
    // Boundary observers
    #startObserver = null;
    #endObserver = null;
    // Zone state: sentinel visibility + boundary tracking
    #sentinelVisible = true;
    #pastStart = true;
    #beforeEnd = true;
    /** Whether sticky mode is enabled via data attribute */
    get isSticky() {
      return this.hasAttribute(stickyAttr);
    }
    /** The sticky position from the data attribute (validated, defaults to bottom-right) */
    get stickyPosition() {
      const raw = this.getAttribute(positionAttr);
      if (raw && STICKY_POSITIONS.has(raw)) {
        return raw;
      }
      return DEFAULT_STICKY_POSITION;
    }
    /** Whether the element is currently in sticky (fixed) mode */
    get isStickyActive() {
      return this.#stickyActive;
    }
    /** Whether the viewport is currently within the configured sticky zone */
    get #inStickyZone() {
      return this.#pastStart && this.#beforeEnd;
    }
    /** Initializes sticky behavior by inserting a sentinel and observing it */
    initSticky() {
      if (!this.isSticky || !this.parentNode) {
        return;
      }
      this.destroySticky();
      this.#sentinelVisible = true;
      this.#pastStart = true;
      this.#beforeEnd = true;
      this.#stickySentinel = createSentinel();
      this.parentNode.insertBefore(this.#stickySentinel, this);
      this.#stickyObserver = new IntersectionObserver(([entry]) => {
        this.#sentinelVisible = entry.isIntersecting;
        this.#updateStickyState();
      });
      this.#stickyObserver.observe(this.#stickySentinel);
      this.#initBoundaryObservers();
    }
    /** Creates a boundary IntersectionObserver for the section matching the given attribute's CSS selector */
    #observeBoundary(attr, updateFlag) {
      const selector = this.getAttribute(attr);
      if (!selector) {
        return null;
      }
      const el = findSectionElement(selector);
      if (!el) {
        return null;
      }
      const observer = new IntersectionObserver(([entry]) => {
        updateFlag(entry);
        this.#updateStickyState();
      });
      observer.observe(el);
      return observer;
    }
    /** Sets up IntersectionObservers for start/end section boundaries */
    #initBoundaryObservers() {
      this.#startObserver = this.#observeBoundary(startSectionAttr, (entry) => {
        this.#pastStart = entry.isIntersecting || isBoundaryAboveViewport(entry);
      });
      if (this.#startObserver) {
        this.#pastStart = false;
      }
      this.#endObserver = this.#observeBoundary(endSectionAttr, (entry) => {
        this.#beforeEnd = entry.isIntersecting || !isBoundaryAboveViewport(entry);
      });
      if (this.#endObserver) {
        this.#beforeEnd = false;
      }
    }
    /** Re-evaluates sticky state based on sentinel visibility and zone boundaries */
    #updateStickyState() {
      if (!this.#sentinelVisible && this.#inStickyZone) {
        this.#activateSticky();
      } else {
        this.#deactivateSticky();
      }
    }
    /** Cleans up the sentinel, observer, timer, and resets styles immediately */
    destroySticky() {
      if (this.#deactivateTimer) {
        clearTimeout(this.#deactivateTimer);
        this.#deactivateTimer = null;
      }
      if (this.#stickyObserver) {
        this.#stickyObserver.disconnect();
        this.#stickyObserver = null;
      }
      if (this.#startObserver) {
        this.#startObserver.disconnect();
        this.#startObserver = null;
      }
      if (this.#endObserver) {
        this.#endObserver.disconnect();
        this.#endObserver = null;
      }
      if (this.#stickySentinel) {
        this.#stickySentinel.remove();
        this.#stickySentinel = null;
      }
      this.#clearStickyStyles();
    }
    /** Applies fixed positioning to pin the element at the chosen screen position */
    #activateSticky() {
      if (this.#deactivateTimer) {
        clearTimeout(this.#deactivateTimer);
        this.#deactivateTimer = null;
      }
      if (this.#stickyActive) {
        this.style.opacity = "";
        this.style.transition = "";
        return;
      }
      const offsetX = this.getAttribute(offsetXAttr) || DEFAULT_STICKY_OFFSET;
      const offsetY = this.getAttribute(offsetYAttr) || DEFAULT_STICKY_OFFSET;
      const styles = buildStickyStyles(this.stickyPosition, offsetX, offsetY);
      this.style.position = STICKY_CSS_POSITION;
      this.style.zIndex = STICKY_Z_INDEX;
      this.style.width = styles.width;
      this.style.transform = styles.transform;
      this.style.top = styles.top;
      this.style.bottom = styles.bottom;
      this.style.left = styles.left;
      this.style.right = styles.right;
      this.classList.add(activeClass);
      this.#stickyActive = true;
    }
    /** Removes fixed positioning with a fade-out transition */
    #deactivateSticky() {
      if (!this.#stickyActive) {
        return;
      }
      this.style.transition = STICKY_DEACTIVATE_TRANSITION;
      this.style.opacity = STICKY_DEACTIVATE_OPACITY;
      this.#deactivateTimer = setTimeout(() => {
        this.#deactivateTimer = null;
        this.#clearStickyStyles();
      }, STICKY_DEACTIVATE_DURATION_MS);
    }
    /** Immediately clears all sticky styles (called after fade-out or on destroy) */
    #clearStickyStyles() {
      this.classList.remove(activeClass);
      this.style.position = "";
      this.style.zIndex = "";
      this.style.width = "";
      this.style.transform = "";
      this.style.top = "";
      this.style.bottom = "";
      this.style.left = "";
      this.style.right = "";
      this.style.opacity = "";
      this.style.transition = "";
      this.#stickyActive = false;
    }
  };
}
function Trackable(Base, config) {
  const { category, errorPrefix = category } = config;
  return class TrackableClass extends Base {
    /** Sends an analytics tracking event via safeTrackEvent */
    track(action, payload) {
      try {
        window.safeTrackEvent?.(category, action, JSON.stringify(payload));
      } catch (error) {
        console.error(`[${errorPrefix}] Failed to track event:`, action, error);
      }
    }
  };
}
const HTML_ESCAPE_MAP = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};
const HTML_ESCAPE_REGEX = new RegExp(`[${Object.keys(HTML_ESCAPE_MAP).join("")}]`, "g");
const formatCentsToMoney = (priceInCents) => window.Shopify?.formatMoney?.(priceInCents) ?? `${FALLBACK_MONEY_PREFIX}${(priceInCents / CENTS_DIVISOR).toFixed(DECIMAL_PLACES)}`;
const formatMoney = (cents) => new Intl.NumberFormat(void 0, {
  style: INTL_STYLE_CURRENCY,
  currency: window.Shopify?.currency?.active || DEFAULT_CURRENCY,
  currencyDisplay: INTL_CURRENCY_DISPLAY_NARROW
}).format(cents / CENTS_DIVISOR);
const formatDiscountText = (template, discount) => template.replace("{discount}", String(discount));
const escapeHtml = (str) => str.replace(HTML_ESCAPE_REGEX, (char) => HTML_ESCAPE_MAP[char]);
class ZygCtaButton extends Stickable(
  Actionable(
    Trackable(HTMLElement, {
      category: ANALYTICS_CATEGORY$2,
      errorPrefix: ANALYTICS_CATEGORY$2
    }),
    {
      keyAttr: ATTR_VARIANT_ID,
      loadingClass: CLASS_LOADING,
      errorPrefix: ANALYTICS_CATEGORY$2
    }
  ),
  { activeClass: CLASS_STICKY_VISIBLE }
) {
  #addedFeedbackTimer = null;
  #initialOfferType = null;
  #complementaryVariantId = null;
  #complementaryQuantity = DEFAULT_QUANTITY$1;
  connectedCallback() {
    this.addEventListener(EVENT_CLICK, this.#handleClick);
    document.addEventListener(DOM_EVENT_VARIANT_CHANGE$2, this.#handleVariantChange);
    document.addEventListener(DOM_EVENT_OFFER_CHANGE$1, this.#handleOfferChange);
    window.addEventListener("pageshow", this.#handlePageShow);
    this.#updateStockWarning();
    this.#updateAvailability();
    this.#captureInitialOfferState();
    this.initSticky();
  }
  disconnectedCallback() {
    this.removeEventListener(EVENT_CLICK, this.#handleClick);
    document.removeEventListener(DOM_EVENT_VARIANT_CHANGE$2, this.#handleVariantChange);
    document.removeEventListener(DOM_EVENT_OFFER_CHANGE$1, this.#handleOfferChange);
    window.removeEventListener("pageshow", this.#handlePageShow);
    if (this.#addedFeedbackTimer) {
      clearTimeout(this.#addedFeedbackTimer);
    }
    this.destroySticky();
  }
  /** Gets the action type from data attribute */
  get action() {
    return this.getAttribute(ATTR_ACTION$1) || ACTION_ADD_TO_CART$1;
  }
  /** Gets the variant ID */
  get variantId() {
    return this.getAttribute(ATTR_VARIANT_ID);
  }
  /** Gets the quantity to add */
  get quantity() {
    const qty = this.getAttribute(ATTR_QUANTITY);
    return qty ? parseInt(qty, RADIX_DECIMAL$1) : DEFAULT_QUANTITY$1;
  }
  /** Gets the selling plan ID for subscriptions */
  get sellingPlanId() {
    return this.getAttribute(ATTR_SELLING_PLAN);
  }
  /** Gets the scroll target selector */
  get scrollTarget() {
    return this.getAttribute(ATTR_SCROLL_TARGET);
  }
  /** Gets the link URL */
  get linkUrl() {
    return this.getAttribute(ATTR_LINK_URL);
  }
  /** Gets whether to open link in new tab */
  get openNewTab() {
    return this.hasAttribute(ATTR_OPEN_NEW_TAB);
  }
  /** Gets whether the variant is available */
  get isAvailable() {
    return this.getAttribute(ATTR_AVAILABLE) === "true";
  }
  /** Handles click events on the button */
  #handleClick = (event) => {
    if (!event.target.closest(SELECTOR_BUTTON)) {
      return;
    }
    event.preventDefault();
    const actionEvent = getActionEvent(this.action);
    if (actionEvent.requiresAvailability && !this.isAvailable) {
      return;
    }
    const context = this.#buildActionContext();
    this.track("cta_click", actionEvent.buildEventDetail(context));
    this.#executeAction(actionEvent, context);
  };
  /** Handles variant change events from product forms */
  #handleVariantChange = (event) => {
    const { variant, productId } = event.detail || {
      variant: void 0,
      productId: void 0
    };
    if (!this.dataset.productId) {
      return;
    }
    if (productId && this.dataset.productId !== productId) {
      return;
    }
    if (!variant) {
      return;
    }
    this.#updateFromVariant(variant);
  };
  /** Handles offer change events from offer picker */
  #handleOfferChange = (event) => {
    const detail = event.detail || {
      sellingPlanId: void 0,
      price: void 0,
      compareAtPrice: void 0,
      productId: void 0,
      variantId: void 0
    };
    if (!detail) {
      return;
    }
    if (!this.dataset.productId) {
      return;
    }
    if (detail.productId && this.dataset.productId !== detail.productId) {
      return;
    }
    if (detail.variantId) {
      this.setAttribute(ATTR_VARIANT_ID, String(detail.variantId));
    }
    if (detail.sellingPlanId) {
      this.setAttribute(ATTR_SELLING_PLAN, String(detail.sellingPlanId));
    } else {
      this.removeAttribute(ATTR_SELLING_PLAN);
    }
    if (isDefined(detail.price)) {
      this.setAttribute(ATTR_PRICE, String(detail.price));
      this.#updatePriceDisplay(detail.price);
    }
    if (isDefined(detail.compareAtPrice) && !this.hasAttribute(ATTR_HIDE_COMPARE_PRICE)) {
      this.setAttribute(ATTR_COMPARE_PRICE, String(detail.compareAtPrice));
      this.#updateComparePriceDisplay(detail.compareAtPrice);
    } else {
      this.removeAttribute(ATTR_COMPARE_PRICE);
      this.#setElementVisibility(SELECTOR_COMPARE_PRICE, false);
    }
    this.#complementaryVariantId = detail.complementaryVariantId ?? null;
    this.#complementaryQuantity = detail.complementaryQuantity ?? DEFAULT_QUANTITY$1;
  };
  /** Resets button state when page is restored from bfcache (e.g., after back navigation from checkout) */
  #handlePageShow = (event) => {
    if (event.persisted) {
      this.setLoading(false);
    }
  };
  /** Checks if an offer picker exists for this product */
  #hasOfferPicker() {
    const productId = this.dataset.productId;
    if (!productId) {
      return false;
    }
    return !!document.querySelector(`${SELECTOR_OFFER_PICKER}[data-product-id="${productId}"]`);
  }
  /** Updates the component based on new variant data */
  #updateFromVariant(variant) {
    this.setAttribute(ATTR_VARIANT_ID, String(variant.id));
    this.setAttribute(ATTR_AVAILABLE, String(variant.available));
    this.#updateAvailability();
    if (!this.#hasOfferPicker()) {
      if (isDefined(variant.price)) {
        this.setAttribute(ATTR_PRICE, String(variant.price));
        this.#updatePriceDisplay(variant.price);
      }
      if (isDefined(variant.compare_at_price) && !this.hasAttribute(ATTR_HIDE_COMPARE_PRICE)) {
        this.setAttribute(ATTR_COMPARE_PRICE, String(variant.compare_at_price));
        this.#updateComparePriceDisplay(variant.compare_at_price);
      } else {
        this.removeAttribute(ATTR_COMPARE_PRICE);
        this.#setElementVisibility(SELECTOR_COMPARE_PRICE, false);
      }
      if (isDefined(variant.unit_price)) {
        this.setAttribute(ATTR_UNIT_PRICE, String(variant.unit_price));
        this.#updateUnitPriceDisplay(
          variant.unit_price,
          (variant.unit_price_measurement?.reference_unit || this.getAttribute(ATTR_UNIT_LABEL)) ?? void 0
        );
      } else {
        this.removeAttribute(ATTR_UNIT_PRICE);
        this.#setElementVisibility(SELECTOR_UNIT_PRICE, false);
      }
    }
    if (VARIANT_INVENTORY_QUANTITY_KEY in variant && isDefined(variant.inventory_quantity)) {
      this.setAttribute(ATTR_STOCK_QUANTITY, String(variant.inventory_quantity));
      this.#updateStockWarning();
    }
  }
  /** Updates the price display element */
  #updatePriceDisplay(price) {
    const priceEl = this.querySelector(SELECTOR_PRICE);
    if (!priceEl) {
      return;
    }
    priceEl.textContent = formatMoney(price);
  }
  /** Updates the compare price display element */
  #updateComparePriceDisplay(comparePrice) {
    const compareEl = this.#setElementVisibility(SELECTOR_COMPARE_PRICE, true);
    if (!compareEl) {
      return;
    }
    compareEl.textContent = formatMoney(comparePrice);
  }
  /** Updates the unit price display */
  #updateUnitPriceDisplay(unitPrice, label) {
    const unitPriceEl = this.#setElementVisibility(SELECTOR_UNIT_PRICE, true);
    if (!unitPriceEl) {
      return;
    }
    const valueEl = unitPriceEl.querySelector(SELECTOR_UNIT_PRICE_VALUE);
    if (valueEl) {
      valueEl.textContent = formatMoney(unitPrice);
    }
    if (label) {
      const labelEl = unitPriceEl.querySelector(SELECTOR_UNIT_PRICE_LABEL);
      if (labelEl) {
        labelEl.textContent = UNIT_PRICE_LABEL_PREFIX + label;
      }
    }
  }
  /** Sets element visibility by selector */
  #setElementVisibility(selector, visible) {
    const el = this.querySelector(selector);
    if (!el) {
      return null;
    }
    el.style.display = visible ? "" : DISPLAY_NONE;
    return el;
  }
  /** Updates text content from a template with placeholder replacements */
  #updateTemplateText(container, textSelector, templateKey, defaultTemplate, value) {
    const textEl = container.querySelector(textSelector);
    if (!textEl) {
      return;
    }
    textEl.textContent = (container.dataset[templateKey] || defaultTemplate).replace(
      PLACEHOLDER_COUNT,
      value
    );
  }
  /** Updates the availability state */
  #updateAvailability() {
    const actionEvent = getActionEvent(this.action);
    const shouldDisable = actionEvent.requiresAvailability && !this.isAvailable;
    const button = this.querySelector(SELECTOR_BUTTON);
    if (button) {
      button.disabled = shouldDisable;
    }
    this.classList.toggle(CLASS_DISABLED, shouldDisable);
  }
  /** Sets loading state */
  #setLoading(loading2) {
    this.classList.toggle(CLASS_LOADING, loading2);
    const actionEvent = getActionEvent(this.action);
    const shouldDisable = loading2 || actionEvent.requiresAvailability && !this.isAvailable;
    const button = this.querySelector(SELECTOR_BUTTON);
    if (button) {
      button.disabled = shouldDisable;
    }
  }
  /** Updates the stock warning display */
  #updateStockWarning() {
    const stockEl = this.querySelector(SELECTOR_STOCK_WARNING);
    if (!stockEl) {
      return;
    }
    const { shouldShow, count } = this.getAttribute(ATTR_STOCK_MODE) === STOCK_MODE_MOCK ? this.#getMockStockDisplay() : this.#getRealStockDisplay();
    stockEl.style.display = shouldShow ? "" : "none";
    if (shouldShow) {
      this.#updateTemplateText(
        stockEl,
        SELECTOR_STOCK_TEXT,
        "stockTemplate",
        DEFAULT_STOCK_TEXT,
        count
      );
    }
  }
  /** Gets mock stock display configuration */
  #getMockStockDisplay() {
    return {
      shouldShow: true,
      count: this.getAttribute(ATTR_MOCK_STOCK_COUNT) || DEFAULT_MOCK_STOCK_COUNT
    };
  }
  /** Gets real stock display configuration based on inventory */
  #getRealStockDisplay() {
    const stockQty = this.getAttribute(ATTR_STOCK_QUANTITY);
    const threshold = this.getAttribute(ATTR_STOCK_THRESHOLD);
    if (!stockQty || !threshold) {
      return { shouldShow: false, count: DEFAULT_NO_STOCK_COUNT };
    }
    const qty = parseInt(stockQty, RADIX_DECIMAL$1);
    return {
      shouldShow: qty > 0 && qty <= parseInt(threshold, RADIX_DECIMAL$1),
      count: String(qty)
    };
  }
  /** Builds action context for event handling */
  #buildActionContext() {
    return {
      variantId: this.variantId,
      productId: this.dataset.productId,
      quantity: this.quantity,
      sellingPlanId: this.sellingPlanId,
      linkUrl: this.linkUrl,
      scrollTarget: this.scrollTarget,
      openNewTab: this.openNewTab,
      isUpsell: this.hasAttribute(ATTR_IS_UPSELL),
      complementaryVariantId: this.#complementaryVariantId,
      complementaryQuantity: this.#complementaryQuantity
    };
  }
  /** Executes an action - delegates to the action's execute method */
  #executeAction(actionEvent, context) {
    const validation = actionEvent.validate(context);
    if (!validation.valid) {
      console.error(validation.error);
      return;
    }
    actionEvent.execute(context, this);
  }
  /** Sets the loading state */
  setLoading(loading2) {
    this.#setLoading(loading2);
    if (loading2) {
      this.classList.remove(CLASS_ADDED);
    }
  }
  /** Shows added feedback temporarily */
  showAddedFeedback() {
    if (!this.hasAttribute(ATTR_CART_FEEDBACK)) {
      return;
    }
    if (this.#addedFeedbackTimer) {
      clearTimeout(this.#addedFeedbackTimer);
    }
    this.classList.add(CLASS_ADDED);
    this.#addedFeedbackTimer = setTimeout(() => {
      this.classList.remove(CLASS_ADDED);
      this.#addedFeedbackTimer = null;
    }, ADDED_FEEDBACK_DURATION);
  }
  /** Emits DOM event and tracks analytics */
  emitAndTrack(domEvent, analyticsAction, detail) {
    emitDomEvent(domEvent, detail);
    this.track(analyticsAction, detail);
  }
  /** Emits error DOM event and tracks error analytics */
  emitError(domEvent, analyticsAction, detail) {
    emitDomEvent(domEvent, detail);
    this.track(analyticsAction, detail);
  }
  /** Captures the initial offer picker state when component loads */
  #captureInitialOfferState() {
    setTimeout(() => {
      const offerPicker = document.querySelector(SELECTOR_OFFER_PICKER);
      if (!offerPicker) {
        this.#initialOfferType = this.sellingPlanId ? OFFER_TYPE_SUBSCRIPTION : OFFER_TYPE_OTP$1;
        return;
      }
      const pickerProductId = offerPicker.dataset.productId;
      if (pickerProductId && this.dataset.productId !== pickerProductId) {
        this.#initialOfferType = this.sellingPlanId ? OFFER_TYPE_SUBSCRIPTION : OFFER_TYPE_OTP$1;
        return;
      }
      const defaultSelection = offerPicker.getAttribute(ATTR_DEFAULT_SELECTION$1) || OFFER_TYPE_SUBSCRIPTION;
      this.#initialOfferType = defaultSelection === OFFER_TYPE_OTP$1 ? OFFER_TYPE_OTP$1 : OFFER_TYPE_SUBSCRIPTION;
    }, 0);
  }
  /** Executes the cart add API call */
  async executeCartAdd(context, options) {
    if (!context.variantId) {
      throw new Error("[cta] Missing variant ID");
    }
    const cartApi = await whenCartReady();
    if (options?.clearFirst) {
      await cartApi.clear();
    }
    await cartApi.addWithComplementary(
      {
        id: context.variantId,
        quantity: context.quantity,
        source: context.isUpsell ? SOURCE_UPSELL : SOURCE_CTA_BUTTON,
        initialOffer: this.#initialOfferType ?? void 0,
        isUpsell: context.isUpsell,
        sellingPlan: context.sellingPlanId || void 0,
        customProperties: context.properties
      },
      context.complementaryVariantId,
      context.complementaryQuantity ?? DEFAULT_QUANTITY$1
    );
    document.dispatchEvent(
      new CustomEvent(DOM_EVENT_CART_ADD$1, {
        bubbles: true,
        detail: {
          data: {
            source: EVENT_SOURCE_PRODUCT_FORM$1,
            skipDrawer: options?.skipDrawer ?? false
          }
        }
      })
    );
  }
  /** Updates variant from external source */
  updateVariant(variant) {
    this.#updateFromVariant(variant);
  }
  /** Updates price display */
  updatePrice(price, comparePrice) {
    this.#updatePriceDisplay(price);
    if (isDefined(comparePrice)) {
      this.#updateComparePriceDisplay(comparePrice);
    }
  }
  /** Updates stock quantity */
  updateStock(quantity) {
    this.setAttribute(ATTR_STOCK_QUANTITY, String(quantity));
    this.#updateStockWarning();
  }
  /** Updates unit price */
  updateUnitPrice(unitPrice, label) {
    this.setAttribute(ATTR_UNIT_PRICE, String(unitPrice));
    this.#updateUnitPriceDisplay(unitPrice, label);
  }
}
if (!customElements.get(ELEMENT_NAME$2)) {
  customElements.define(ELEMENT_NAME$2, ZygCtaButton);
}
const ELEMENT_NAME$1 = "zyg-variant-picker";
const ANALYTICS_CATEGORY$1 = "variant_picker";
const CLASS_SELECTED$1 = "zyg-variant-picker__option--selected";
const CLASS_SWATCH_SELECTED = "is-selected";
const DISPLAY_MODE_PILLS = "pills";
const DISPLAY_MODE_DROPDOWN = "dropdown";
const DISPLAY_MODE_COLOR_SWATCHES = "color_swatches";
const DISCOUNT_SOURCE_OTP = "otp";
const DISCOUNT_SOURCE_SUBSCRIPTION = "subscription";
const DISCOUNT_SOURCE_MAX = "max";
const DEFAULT_DISCOUNT_SOURCE = DISCOUNT_SOURCE_MAX;
const ATTR_DISPLAY_MODE = "data-display-mode";
const ATTR_SHOW_DISCOUNT = "data-show-discount";
const ATTR_DISCOUNT_TEMPLATE = "data-discount-template";
const ATTR_DISCOUNT_SOURCE = "data-discount-source";
const ATTR_UPDATE_URL = "data-update-url";
const ATTR_NAVIGATE_GALLERY = "data-navigate-gallery";
const SELECTOR_OPTION = ".zyg-variant-picker__option";
const SELECTOR_DROPDOWN = ".zyg-variant-picker__dropdown";
const SELECTOR_VARIANTS_DATA = "[data-variants]";
const SELECTOR_DISCOUNT = ".zyg-variant-picker__discount";
const SELECTOR_SWATCH_ITEM = ".zyg-variant-picker__swatch-item";
const SELECTOR_SWATCHES = ".zyg-variant-picker__swatches";
const ATTR_SWATCH_VALUE = "data-swatch-value";
const ATTR_OPTION_POSITION = "data-option-position";
const SELECTOR_DROPDOWN_IMAGE = "[data-variant-image]";
const SELECTOR_DROPDOWN_DISCOUNT = "[data-variant-discount]";
const DOM_EVENT_VARIANT_CHANGE$1 = "zyg:variant:change";
const DOM_EVENT_LOCAL_VARIANT_CHANGE = "variant-change";
const URL_PARAM_VARIANT = "variant";
const GALLERY_WRAPPER_ID_PREFIX = "product-media-";
const ATTR_MEDIA_ID = "data-media-id";
const SELECTOR_PRODUCT_GALLERY = "product-gallery";
const ARIA_PRESSED = "aria-pressed";
const ANALYTICS_ACTION_SELECT$1 = "variant_select";
const ANALYTICS_ACTION_VIEW$1 = "variant_picker_view";
const ERROR_PARSE_VARIANTS = "[variant-picker] Failed to parse variants data";
const PLACEHOLDER_DISCOUNT = "{discount}";
const DEFAULT_DISCOUNT_TEMPLATE = "Save {discount}%";
const calculateDiscount = (price, compareAtPrice) => {
  if (!compareAtPrice || compareAtPrice <= price) {
    return 0;
  }
  return Math.ceil((compareAtPrice - price) / compareAtPrice * PERCENTAGE_MULTIPLIER);
};
class VariantDisplayMode {
}
class DropdownDisplayMode extends VariantDisplayMode {
  constructor() {
    super(...arguments);
    this.type = DISPLAY_MODE_DROPDOWN;
    this.#changeHandler = null;
    this.#dropdown = null;
  }
  #changeHandler;
  #dropdown;
  /**
   * Binds change event listener to dropdown select
   *
   * @param context - The display mode context
   * @param container - The container component for callbacks
   */
  bind(context, container) {
    this.#dropdown = context.element.querySelector(SELECTOR_DROPDOWN);
    if (!this.#dropdown) {
      return;
    }
    this.#changeHandler = (event) => this.#handleChange(event, container);
    this.#dropdown.addEventListener(EVENT_CHANGE, this.#changeHandler);
  }
  /**
   * Unbinds change event listener
   *
   * @param _context - The display mode context (unused)
   */
  unbind(_context) {
    if (this.#dropdown && this.#changeHandler) {
      this.#dropdown.removeEventListener(EVENT_CHANGE, this.#changeHandler);
      this.#changeHandler = null;
      this.#dropdown = null;
    }
  }
  /**
   * Updates selected state on dropdown and related elements
   *
   * @param context - The display mode context
   * @param variantId - The variant ID to mark as selected
   */
  updateSelectedState(context, variantId) {
    const dropdown = context.element.querySelector(SELECTOR_DROPDOWN);
    if (dropdown) {
      dropdown.value = variantId;
    }
    const variant = context.variants.find((v) => String(v.id) === variantId);
    if (!variant) {
      return;
    }
    this.#updateDropdownImage(context, variant);
    this.#updateDropdownDiscount(context, variant);
  }
  /**
   * Updates the dropdown image preview
   *
   * @param context - The display mode context
   * @param variant - The variant data with image info
   */
  #updateDropdownImage(context, variant) {
    const imageElement = context.element.querySelector(SELECTOR_DROPDOWN_IMAGE);
    if (!imageElement) {
      return;
    }
    if (variant.featured_image) {
      imageElement.src = variant.featured_image.src;
      imageElement.alt = variant.featured_image.alt || variant.title;
      show(imageElement.parentElement);
    } else {
      hide(imageElement.parentElement);
    }
  }
  /**
   * Updates the dropdown discount badge
   *
   * @param context - The display mode context
   * @param variant - The variant data with price info
   */
  #updateDropdownDiscount(context, variant) {
    const discountElement = context.element.querySelector(
      SELECTOR_DROPDOWN_DISCOUNT
    );
    if (!discountElement) {
      return;
    }
    const discountSource = context.element.getAttribute(ATTR_DISCOUNT_SOURCE) || DISCOUNT_SOURCE_MAX;
    const discount = this.#calculateVariantDiscount(variant, discountSource);
    if (discount > 0) {
      const template = context.element.getAttribute(ATTR_DISCOUNT_TEMPLATE) || DEFAULT_DISCOUNT_TEMPLATE;
      discountElement.textContent = template.replace(PLACEHOLDER_DISCOUNT, String(discount));
      show(discountElement);
    } else {
      hide(discountElement);
    }
  }
  /**
   * Calculates discount for a variant based on source (OTP, subscription, or max)
   *
   * @param variant - The variant data
   * @param source - Which discount to calculate
   * @returns Discount percentage (0-100)
   */
  #calculateVariantDiscount(variant, source) {
    const basePrice = variant.compare_at_price || variant.price;
    const otpDiscount = calculateDiscount(variant.price, variant.compare_at_price);
    const maxSubscriptionDiscount = Math.max(
      0,
      ...(variant.selling_plans || []).map((plan) => calculateDiscount(plan.price, basePrice))
    );
    switch (source) {
      case DISCOUNT_SOURCE_OTP:
        return otpDiscount;
      case DISCOUNT_SOURCE_SUBSCRIPTION:
        return maxSubscriptionDiscount;
      case DISCOUNT_SOURCE_MAX:
        return Math.max(otpDiscount, maxSubscriptionDiscount);
      default:
        return Math.max(otpDiscount, maxSubscriptionDiscount);
    }
  }
  /**
   * Handle change event on dropdown select
   *
   * @param event - The change event
   * @param container - The container component for callbacks
   */
  #handleChange(event, container) {
    const select = event.target;
    if (!select.value || select.value === container.getSelectedVariantId()) {
      return;
    }
    container.selectVariant(select.value);
  }
}
class PillsDisplayMode extends VariantDisplayMode {
  constructor() {
    super(...arguments);
    this.type = DISPLAY_MODE_PILLS;
    this.#clickHandler = null;
  }
  #clickHandler;
  /**
   * Binds click event listener for pill selection and initializes discount badges
   *
   * @param context - The display mode context
   * @param container - The container component for callbacks
   */
  bind(context, container) {
    this.#clickHandler = (event) => this.#handleClick(event, container);
    context.element.addEventListener(EVENT_CLICK, this.#clickHandler);
    this.#updateAllDiscountBadges(context);
  }
  /**
   * Unbinds click event listener
   *
   * @param context - The display mode context
   */
  unbind(context) {
    if (this.#clickHandler) {
      context.element.removeEventListener(EVENT_CLICK, this.#clickHandler);
      this.#clickHandler = null;
    }
  }
  /**
   * Updates selected state on all pill options and refreshes discount badges
   *
   * @param context - The display mode context
   * @param variantId - The variant ID to mark as selected
   */
  updateSelectedState(context, variantId) {
    context.element.querySelectorAll(SELECTOR_OPTION).forEach((option) => {
      const isSelected = option.getAttribute(ATTR_VARIANT_ID) === variantId;
      option.classList.toggle(CLASS_SELECTED$1, isSelected);
      option.setAttribute(ARIA_PRESSED, String(isSelected));
    });
    this.#updateAllDiscountBadges(context);
  }
  /**
   * Updates discount badges for all pills based on current variant data
   *
   * @param context - The display mode context
   */
  #updateAllDiscountBadges(context) {
    const discountSource = context.element.getAttribute(ATTR_DISCOUNT_SOURCE) || DISCOUNT_SOURCE_MAX;
    const template = context.element.getAttribute(ATTR_DISCOUNT_TEMPLATE) || DEFAULT_DISCOUNT_TEMPLATE;
    context.element.querySelectorAll(SELECTOR_OPTION).forEach((option) => {
      const optionVariantId = option.getAttribute(ATTR_VARIANT_ID);
      if (!optionVariantId) {
        return;
      }
      const variant = context.variants.find((v) => String(v.id) === optionVariantId);
      if (!variant) {
        return;
      }
      const discountElement = option.querySelector(SELECTOR_DISCOUNT);
      if (!discountElement) {
        return;
      }
      const discount = this.#calculateVariantDiscount(variant, discountSource);
      if (discount > 0) {
        discountElement.textContent = template.replace(
          PLACEHOLDER_DISCOUNT,
          String(discount)
        );
        show(discountElement);
      } else {
        hide(discountElement);
      }
    });
  }
  /**
   * Calculates discount for a variant based on source (OTP, subscription, or max)
   *
   * @param variant - The variant data
   * @param source - Which discount to calculate
   * @returns Discount percentage (0-100)
   */
  #calculateVariantDiscount(variant, source) {
    const basePrice = variant.compare_at_price || variant.price;
    const otpDiscount = calculateDiscount(variant.price, variant.compare_at_price);
    const maxSubscriptionDiscount = Math.max(
      0,
      ...(variant.selling_plans || []).map((plan) => calculateDiscount(plan.price, basePrice))
    );
    switch (source) {
      case DISCOUNT_SOURCE_OTP:
        return otpDiscount;
      case DISCOUNT_SOURCE_SUBSCRIPTION:
        return maxSubscriptionDiscount;
      case DISCOUNT_SOURCE_MAX:
        return Math.max(otpDiscount, maxSubscriptionDiscount);
      default:
        return Math.max(otpDiscount, maxSubscriptionDiscount);
    }
  }
  /**
   * Handle click event on pill options
   *
   * @param event - The click event
   * @param container - The container component for callbacks
   */
  #handleClick(event, container) {
    const option = event.target.closest(SELECTOR_OPTION);
    if (!option) {
      return;
    }
    const variantId = option.getAttribute(ATTR_VARIANT_ID);
    if (!variantId || variantId === container.getSelectedVariantId()) {
      return;
    }
    container.selectVariant(variantId);
  }
}
class SwatchesDisplayMode extends VariantDisplayMode {
  constructor() {
    super(...arguments);
    this.type = DISPLAY_MODE_COLOR_SWATCHES;
    this.#clickHandler = null;
    this.#keydownHandler = null;
  }
  #clickHandler;
  #keydownHandler;
  /**
   * Binds click and keyboard event listeners for swatch selection
   *
   * @param context - The display mode context
   * @param container - The container component for callbacks
   */
  bind(context, container) {
    this.#clickHandler = (event) => this.#handleClick(event, context, container);
    this.#keydownHandler = (event) => this.#handleKeydown(event, context, container);
    context.element.addEventListener(EVENT_CLICK, this.#clickHandler);
    context.element.addEventListener("keydown", this.#keydownHandler);
  }
  /**
   * Unbinds event listeners
   *
   * @param context - The display mode context
   */
  unbind(context) {
    if (this.#clickHandler) {
      context.element.removeEventListener(EVENT_CLICK, this.#clickHandler);
      this.#clickHandler = null;
    }
    if (this.#keydownHandler) {
      context.element.removeEventListener("keydown", this.#keydownHandler);
      this.#keydownHandler = null;
    }
  }
  /**
   * Updates selected state on all swatch items to match the given variant
   *
   * @param context - The display mode context
   * @param variantId - The variant ID to mark as selected
   */
  updateSelectedState(context, variantId) {
    const variant = context.variants.find((v) => String(v.id) === variantId);
    if (!variant) {
      return;
    }
    const swatchesEl = context.element.querySelector(SELECTOR_SWATCHES);
    if (!swatchesEl) {
      return;
    }
    const optionPosition = parseInt(swatchesEl.getAttribute(ATTR_OPTION_POSITION) || "1", 10);
    const selectedColorValue = variant.options[optionPosition - 1];
    context.element.querySelectorAll(SELECTOR_SWATCH_ITEM).forEach((item) => {
      const isSelected = item.getAttribute(ATTR_SWATCH_VALUE) === selectedColorValue;
      item.classList.toggle(CLASS_SWATCH_SELECTED, isSelected);
      item.setAttribute(ARIA_PRESSED, String(isSelected));
    });
  }
  /**
   * Finds the best-matching variant for a given color value
   *
   * @description Tries to match the color AND preserve other currently-selected option values.
   * Falls back to the first available variant with the matching color.
   *
   * @param variants - All variants for the product
   * @param colorValue - The selected color option value text
   * @param optionPosition - The 1-based position of the color option
   * @param currentVariantId - The currently selected variant ID for preference matching
   * @returns The best-matching variant, or null if none found
   */
  #findBestVariant(variants, colorValue, optionPosition, currentVariantId) {
    const colorIndex = optionPosition - 1;
    const colorMatches = variants.filter((v) => v.options[colorIndex] === colorValue);
    if (colorMatches.length === 0) {
      return null;
    }
    if (currentVariantId) {
      const current = variants.find((v) => String(v.id) === currentVariantId);
      if (current) {
        const preserved = colorMatches.find(
          (v) => v.options.every((opt, i) => i === colorIndex || opt === current.options[i])
        );
        if (preserved) {
          return preserved;
        }
      }
    }
    return colorMatches.find((v) => v.available) ?? colorMatches[0];
  }
  /**
   * Handles click on a swatch item
   *
   * @param event - The click event
   * @param context - The display mode context
   * @param container - The container component for callbacks
   */
  #handleClick(event, context, container) {
    const item = event.target.closest(SELECTOR_SWATCH_ITEM);
    if (!item) {
      return;
    }
    this.#selectFromItem(item, context, container);
  }
  /**
   * Handles keyboard activation (Enter/Space) on a swatch item
   *
   * @param event - The keydown event
   * @param context - The display mode context
   * @param container - The container component for callbacks
   */
  #handleKeydown(event, context, container) {
    const keyEvent = event;
    if (keyEvent.key !== "Enter" && keyEvent.key !== " ") {
      return;
    }
    const item = event.target.closest(SELECTOR_SWATCH_ITEM);
    if (!item) {
      return;
    }
    event.preventDefault();
    this.#selectFromItem(item, context, container);
  }
  /**
   * Selects a variant based on the swatch item that was activated
   *
   * @param item - The activated swatch item element
   * @param context - The display mode context
   * @param container - The container component for callbacks
   */
  #selectFromItem(item, context, container) {
    const colorValue = item.getAttribute(ATTR_SWATCH_VALUE);
    if (!colorValue) {
      return;
    }
    const swatchesEl = context.element.querySelector(SELECTOR_SWATCHES);
    const optionPosition = parseInt(swatchesEl?.getAttribute(ATTR_OPTION_POSITION) || "1", 10);
    const bestVariant = this.#findBestVariant(
      context.variants,
      colorValue,
      optionPosition,
      container.getSelectedVariantId()
    );
    if (!bestVariant) {
      return;
    }
    const variantId = String(bestVariant.id);
    if (variantId === container.getSelectedVariantId()) {
      return;
    }
    container.selectVariant(variantId);
  }
}
const displayModeFactories = {
  [DISPLAY_MODE_PILLS]: () => new PillsDisplayMode(),
  [DISPLAY_MODE_DROPDOWN]: () => new DropdownDisplayMode(),
  [DISPLAY_MODE_COLOR_SWATCHES]: () => new SwatchesDisplayMode()
};
const _ZygVariantPicker = class _ZygVariantPicker extends Trackable(HTMLElement, {
  category: ANALYTICS_CATEGORY$1,
  errorPrefix: ANALYTICS_CATEGORY$1
}) {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ZygVariantPicker_instances);
    __privateAdd(this, _variants, []);
    __privateAdd(this, _selectedVariantId, null);
    __privateAdd(this, _displayModeInstance, null);
  }
  connectedCallback() {
    __privateMethod(this, _ZygVariantPicker_instances, parseVariantsData_fn).call(this);
    __privateSet(this, _displayModeInstance, displayModeFactories[this.displayMode]());
    __privateMethod(this, _ZygVariantPicker_instances, initializeSelectedVariant_fn).call(this);
    __privateMethod(this, _ZygVariantPicker_instances, bindEvents_fn).call(this);
    __privateMethod(this, _ZygVariantPicker_instances, trackView_fn).call(this);
  }
  disconnectedCallback() {
    __privateMethod(this, _ZygVariantPicker_instances, unbindEvents_fn).call(this);
  }
  /**
   * Gets the display mode
   *
   * @returns The current display mode (pills or dropdown)
   */
  get displayMode() {
    return this.getAttribute(ATTR_DISPLAY_MODE) || DISPLAY_MODE_PILLS;
  }
  /**
   * Gets the product ID
   *
   * @returns The product ID from the data attribute
   */
  get productId() {
    return this.getAttribute(ATTR_PRODUCT_ID) || "";
  }
  /**
   * Gets the currently selected variant ID
   *
   * @returns The selected variant ID or null if none selected
   */
  get selectedVariantId() {
    return __privateGet(this, _selectedVariantId);
  }
  /**
   * Gets the currently selected variant
   *
   * @returns The selected variant data or null if none selected
   */
  get selectedVariant() {
    if (!__privateGet(this, _selectedVariantId)) {
      return null;
    }
    return __privateGet(this, _variants).find((v) => String(v.id) === __privateGet(this, _selectedVariantId)) ?? null;
  }
  /**
   * Gets whether to update URL on variant change
   *
   * @returns True if URL should be updated on variant change
   */
  get shouldUpdateUrl() {
    return this.hasAttribute(ATTR_UPDATE_URL);
  }
  /** Returns whether the gallery should navigate to the variant's image on selection */
  get shouldNavigateGallery() {
    return this.hasAttribute(ATTR_NAVIGATE_GALLERY);
  }
  /**
   * Gets the discount text template
   *
   * @returns The template string for discount display
   */
  get discountTemplate() {
    return this.getAttribute(ATTR_DISCOUNT_TEMPLATE) || DEFAULT_DISCOUNT_TEMPLATE;
  }
  /**
   * Gets whether to show discount
   *
   * @returns True if discount badge should be shown
   */
  get showDiscount() {
    return this.hasAttribute(ATTR_SHOW_DISCOUNT);
  }
  /**
   * Gets the discount source setting
   *
   * @returns The discount source: 'otp', 'subscription', or 'max' (default)
   */
  get discountSource() {
    return this.getAttribute(ATTR_DISCOUNT_SOURCE) || DEFAULT_DISCOUNT_SOURCE;
  }
  /**
   * Called by display mode to select a variant
   *
   * @param variantId - The variant ID to select
   */
  selectVariant(variantId) {
    __privateMethod(this, _ZygVariantPicker_instances, doSelectVariant_fn).call(this, variantId);
  }
  /**
   * Called by display mode to get the current selection
   *
   * @returns The currently selected variant ID or null
   */
  getSelectedVariantId() {
    return __privateGet(this, _selectedVariantId);
  }
  /**
   * Public method to get all variants
   *
   * @returns A copy of the variants array
   */
  getVariants() {
    return [...__privateGet(this, _variants)];
  }
};
_variants = new WeakMap();
_selectedVariantId = new WeakMap();
_displayModeInstance = new WeakMap();
_ZygVariantPicker_instances = new WeakSet();
/**
 * Builds the display mode context
 *
 * @returns Context object for display mode operations
 */
buildContext_fn = function() {
  return {
    element: this,
    variants: __privateGet(this, _variants),
    selectedVariantId: __privateGet(this, _selectedVariantId)
  };
};
/** Parse variants JSON data from embedded script tag */
parseVariantsData_fn = function() {
  const variantsScript = this.querySelector(SELECTOR_VARIANTS_DATA);
  if (!variantsScript) {
    return;
  }
  try {
    __privateSet(this, _variants, JSON.parse(variantsScript.textContent || "[]"));
  } catch {
    console.error(ERROR_PARSE_VARIANTS);
    __privateSet(this, _variants, []);
  }
};
/** Initialize selected variant state on connect */
initializeSelectedVariant_fn = function() {
  const currentVariantId = this.getAttribute(ATTR_VARIANT_ID);
  if (currentVariantId) {
    __privateSet(this, _selectedVariantId, currentVariantId);
    __privateMethod(this, _ZygVariantPicker_instances, updateSelectedState_fn).call(this, currentVariantId);
  } else if (__privateGet(this, _variants).length > 0) {
    const firstAvailable = __privateGet(this, _variants).find((v) => v.available) ?? __privateGet(this, _variants)[0];
    __privateSet(this, _selectedVariantId, String(firstAvailable.id));
    this.setAttribute(ATTR_VARIANT_ID, __privateGet(this, _selectedVariantId));
    __privateMethod(this, _ZygVariantPicker_instances, updateSelectedState_fn).call(this, __privateGet(this, _selectedVariantId));
  }
};
/** Bind event listeners via display mode */
bindEvents_fn = function() {
  __privateGet(this, _displayModeInstance)?.bind(__privateMethod(this, _ZygVariantPicker_instances, buildContext_fn).call(this), this);
};
/** Unbind event listeners via display mode */
unbindEvents_fn = function() {
  __privateGet(this, _displayModeInstance)?.unbind(__privateMethod(this, _ZygVariantPicker_instances, buildContext_fn).call(this));
};
/** Select a variant by ID (internal) */
doSelectVariant_fn = function(variantId) {
  const variant = __privateGet(this, _variants).find((v) => String(v.id) === variantId);
  if (!variant) {
    return;
  }
  const previousVariantId = __privateGet(this, _selectedVariantId);
  __privateSet(this, _selectedVariantId, variantId);
  this.setAttribute(ATTR_VARIANT_ID, variantId);
  this.setAttribute(ATTR_AVAILABLE, String(variant.available));
  __privateMethod(this, _ZygVariantPicker_instances, updateSelectedState_fn).call(this, variantId);
  __privateMethod(this, _ZygVariantPicker_instances, emitVariantChange_fn).call(this, variant, previousVariantId);
  if (this.shouldNavigateGallery) {
    __privateMethod(this, _ZygVariantPicker_instances, navigateGallery_fn).call(this, variant);
  }
  __privateMethod(this, _ZygVariantPicker_instances, trackSelect_fn).call(this, variant);
  if (this.shouldUpdateUrl) {
    __privateMethod(this, _ZygVariantPicker_instances, updateUrl_fn).call(this, variantId);
  }
};
/**
 * Navigates the product gallery to the variant's featured image.
 *
 * Uses Dawn's product-gallery `setActiveMedia` API when available,
 * falling back to scrollIntoView for non-Dawn gallery implementations.
 *
 * @param variant - The newly selected variant
 */
navigateGallery_fn = function(variant) {
  if (!variant.featured_image?.id) {
    return;
  }
  const galleryWrapper = document.querySelector(
    `[id^="${GALLERY_WRAPPER_ID_PREFIX}${this.productId}"]`
  );
  if (!galleryWrapper) {
    return;
  }
  const productGallery = galleryWrapper.querySelector(SELECTOR_PRODUCT_GALLERY);
  if (productGallery?.setActiveMedia) {
    productGallery.setActiveMedia(variant.featured_image.id, false);
    return;
  }
  galleryWrapper.querySelector(`[${ATTR_MEDIA_ID}="${variant.featured_image.id}"]`)?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
};
/** Update the selected state in the UI via display mode */
updateSelectedState_fn = function(variantId) {
  __privateGet(this, _displayModeInstance)?.updateSelectedState(__privateMethod(this, _ZygVariantPicker_instances, buildContext_fn).call(this), variantId);
};
/**
 * Emit variant change event
 *
 * @param variant - The newly selected variant data
 * @param previousVariantId - The previously selected variant ID
 */
emitVariantChange_fn = function(variant, previousVariantId) {
  document.dispatchEvent(
    new CustomEvent(DOM_EVENT_VARIANT_CHANGE$1, {
      bubbles: true,
      detail: {
        variant: {
          id: variant.id,
          available: variant.available,
          price: variant.price,
          compare_at_price: variant.compare_at_price,
          featured_image: variant.featured_image,
          options: variant.options,
          title: variant.title
        },
        productId: this.productId
      }
    })
  );
  this.dispatchEvent(
    new CustomEvent(DOM_EVENT_LOCAL_VARIANT_CHANGE, {
      bubbles: true,
      detail: { variant, productId: this.productId, previousVariantId }
    })
  );
};
/**
 * Update URL with variant ID
 *
 * @param variantId - The variant ID to set in URL
 */
updateUrl_fn = function(variantId) {
  const url = new URL(window.location.href);
  url.searchParams.set(URL_PARAM_VARIANT, variantId);
  window.history.replaceState({}, "", url.toString());
};
/** Track view event */
trackView_fn = function() {
  this.track(ANALYTICS_ACTION_VIEW$1, {
    productId: this.productId,
    displayMode: this.displayMode,
    variantCount: __privateGet(this, _variants).length
  });
};
/**
 * Track select event
 *
 * @param variant - The selected variant data
 */
trackSelect_fn = function(variant) {
  this.track(ANALYTICS_ACTION_SELECT$1, {
    productId: this.productId,
    variantId: String(variant.id),
    variantTitle: variant.title,
    price: variant.price,
    available: variant.available
  });
};
_ZygVariantPicker.calculateDiscount = calculateDiscount;
_ZygVariantPicker.formatDiscountText = formatDiscountText;
_ZygVariantPicker.formatMoney = formatMoney;
let ZygVariantPicker = _ZygVariantPicker;
if (!customElements.get(ELEMENT_NAME$1)) {
  customElements.define(ELEMENT_NAME$1, ZygVariantPicker);
}
const ELEMENT_NAME = "zyg-offer-picker";
const VARIANT_PICKER_ELEMENT = "zyg-variant-picker";
const ANALYTICS_CATEGORY = "offer_picker";
const OFFER_TYPE_SELLING_PLAN = "selling_plan";
const OFFER_TYPE_OTP = "otp";
const CLASS_SELECTED = "zyg-offer-picker__offer--selected";
const CLASS_OFFER = "zyg-offer-picker__offer";
const CLASS_MONTHLY_AMOUNT = "zyg-offer-picker__monthly-amount";
const CLASS_MODIFIER_IMAGE = "--image-";
const ATTR_OFFER_TYPE = "data-offer-type";
const ATTR_SELLING_PLAN_ID = "data-selling-plan-id";
const ATTR_DEFAULT_SELECTION = "data-default-selection";
const ATTR_HAS_SELLING_PLANS = "data-has-selling-plans";
const ATTR_OTP_AS_LINK = "data-otp-as-link";
const ATTR_OTP_ACTION = "data-otp-action";
const ATTR_ACTION = "data-action";
const ATTR_OFFER_INDEX = "data-offer-index";
const ATTR_DATA_MONTHLY_AMOUNT = "data-monthly-amount";
const ATTR_DATA_DETAILS = "data-details";
const ATTR_DATA_ADDITIONS = "data-additions";
const SELECTOR_OFFER = ".zyg-offer-picker__offer";
const SELECTOR_OTP_LINK = ".zyg-offer-picker__otp-link";
const SELECTOR_VARIANTS_OFFERS_DATA = "[data-variants-offers]";
const SELECTOR_CONTAINER = ".zyg-offer-picker__container";
const ACTION_ADD_TO_CART = "add-to-cart";
const ACTION_STRAIGHT_TO_CHECKOUT = "straight-to-checkout";
const CHECKOUT_URL = "/checkout";
const DOM_EVENT_OFFER_CHANGE = "zyg:offer:change";
const DOM_EVENT_VARIANT_CHANGE = "zyg:variant:change";
const DOM_EVENT_CART_ADD = "cart:add";
const EVENT_SOURCE_PRODUCT_FORM = "product-form-component";
const ARIA_CHECKED = "aria-checked";
const ANALYTICS_ACTION_SELECT = "offer_select";
const ANALYTICS_ACTION_VIEW = "offer_picker_view";
const ERROR_PARSE_DATA = "[offer-picker] Failed to parse variants offers data";
const ERROR_MISSING_VARIANT_ID = "[offer-picker] Missing variant ID";
const ERROR_ADD_TO_CART_FAILED = "[offer-picker] Failed to add to cart";
const DEFAULT_SELECTION_SUBSCRIPTION = "subscription";
const DEFAULT_SELECTION_OTP = "otp";
const DEFAULT_SELECTION_OFFER_PREFIX = "offer_";
const DEFAULT_OTP_TITLE = "One-Time Purchase";
const DEFAULT_SELLING_PLAN_NAME = "Unknown Selling Plan";
const DEFAULT_ADDITIONS_IMAGE_POSITION = "right";
const DEFAULT_BADGE_POSITION_Y = "top";
const DEFAULT_BADGE_POSITION_X = "right";
const ADDITIONS_IMAGE_WIDTH = 60;
const ADDITIONS_IMAGE_HEIGHT = 60;
const PLACEHOLDER_FREQUENCY = "{frequency}";
const REGEX_HTML_TAGS = /<[^>]*>/g;
const ENTITY_LCUB = "&lcub;";
const ENTITY_RCUB = "&rcub;";
const CHAR_LCUB$1 = "{";
const CHAR_RCUB$1 = "}";
const TIMEOUT_IMMEDIATE = 0;
const SUFFIX_UNIT = "/Unit";
const SUFFIX_MONTH = "/Month";
const MIN_POSITIVE_VALUE = 0;
const OTP_POSITION_TOP = "top";
const DOM_EVENT_LOCAL_OFFER_CHANGE = "offer-change";
const DEFAULT_QUANTITY = 1;
const DEFAULT_COMPLEMENTARY_QUANTITY = 1;
const CLASS_OTP_LINK = "zyg-offer-picker__otp-link";
const CLASS_RADIO = "zyg-offer-picker__radio";
const CLASS_RADIO_DOT = "zyg-offer-picker__radio-dot";
const CLASS_CONTENT = "zyg-offer-picker__content";
const CLASS_TITLE = "zyg-offer-picker__title";
const CLASS_PRICE_CONTAINER = "zyg-offer-picker__price-container";
const CLASS_PRICE = "zyg-offer-picker__price";
const CLASS_COMPARE_PRICE = "zyg-offer-picker__compare-price";
const CLASS_HEADER = "zyg-offer-picker__header";
const CLASS_DETAILS = "zyg-offer-picker__details";
const CLASS_DETAILS_CONTENT = "zyg-offer-picker__details-content";
const CLASS_HAS_DETAILS = "zyg-offer-picker__offer--has-details";
const CLASS_ADDITIONS = "zyg-offer-picker__additions";
const CLASS_ADDITIONS_IMAGE = "zyg-offer-picker__additions-image";
const CLASS_ADDITIONS_CONTENT = "zyg-offer-picker__additions-content";
const CLASS_ADDITIONS_TITLE = "zyg-offer-picker__additions-title";
const CLASS_ADDITIONS_TEXT = "zyg-offer-picker__additions-text";
const CLASS_HAS_ADDITIONS = "zyg-offer-picker__offer--has-additions";
const ATTR_DATA_TITLE = "data-title";
const ATTR_DATA_PRICE = "data-price";
const ATTR_DATA_COMPARE_PRICE = "data-compare-price";
const ATTR_ROLE_RADIO = "radio";
const ATTR_TYPE_BUTTON = "button";
const ATTR_IMG_SRC = "src";
const ATTR_IMG_ALT = "alt";
const ATTR_IMG_LOADING = "loading";
const ATTR_IMG_WIDTH = "width";
const ATTR_IMG_HEIGHT = "height";
const IMG_LOADING_LAZY = "lazy";
const RADIX_DECIMAL = 10;
const FIRST_INDEX = 0;
const ONE_BASED_INDEX_OFFSET = 1;
const FLAT_OTP_INDEX = -1;
const MODE_FLAT = "flat";
const ATTR_MODE = "data-mode";
const ATTR_FLAT_VARIANT_ID = "data-flat-variant-id";
const CLASS_BADGE = "zyg-badge";
const CLASS_BADGE_CORNER = "zyg-badge--corner";
const CLASS_BADGE_INLINE = "zyg-badge--inline";
const CLASS_BADGE_HIDDEN = "zyg-badge--hidden";
const CLASS_BADGE_TOP = "zyg-badge--top";
const CLASS_BADGE_BOTTOM = "zyg-badge--bottom";
const CLASS_BADGE_LEFT = "zyg-badge--left";
const CLASS_BADGE_RIGHT = "zyg-badge--right";
const CLASS_BADGE_TOP_LEFT = "zyg-badge--top-left";
const CLASS_BADGE_TOP_RIGHT = "zyg-badge--top-right";
const CLASS_BADGE_BOTTOM_LEFT = "zyg-badge--bottom-left";
const CLASS_BADGE_BOTTOM_RIGHT = "zyg-badge--bottom-right";
const CLASS_BADGE_DISCOUNT = "zyg-badge--discount";
const CLASS_BADGE_PROMO = "zyg-badge--promo";
const CLASS_BADGE_INFO = "zyg-badge--info";
const CLASS_BADGE_SALE = "zyg-badge--sale";
const CSS_VAR_BADGE_BG = "--badge-bg-color";
const CSS_VAR_BADGE_COLOR = "--badge-text-color";
const ATTR_DATA_BADGE = "data-badge";
const BADGE_PLACEHOLDER_DISCOUNT = "{discount}";
const BADGE_PLACEHOLDER_FREQUENCY = "{frequency}";
const DEFAULT_BADGE_TEXT = "{discount}%";
const VARIANT_CLASS_MAP = {
  discount: CLASS_BADGE_DISCOUNT,
  promo: CLASS_BADGE_PROMO,
  info: CLASS_BADGE_INFO,
  sale: CLASS_BADGE_SALE,
  custom: ""
};
const POSITION_CLASS_MAP = {
  "top-left": CLASS_BADGE_TOP_LEFT,
  "top-right": CLASS_BADGE_TOP_RIGHT,
  "bottom-left": CLASS_BADGE_BOTTOM_LEFT,
  "bottom-right": CLASS_BADGE_BOTTOM_RIGHT,
  inline: CLASS_BADGE_INLINE
};
const POSITION_X_CLASS_MAP = {
  left: CLASS_BADGE_LEFT,
  right: CLASS_BADGE_RIGHT
};
const POSITION_Y_CLASS_MAP = {
  top: CLASS_BADGE_TOP,
  bottom: CLASS_BADGE_BOTTOM
};
const DEFAULT_POSITION_X = "right";
const DEFAULT_POSITION_Y = "top";
const DEFAULT_POSITION = "top-right";
const POSITION_INLINE = "inline";
const VARIANT_CUSTOM = "custom";
const VARIANT_DISCOUNT = "discount";
const VARIANT_PROMO = "promo";
const REGEX_HTML_ENTITY_LCUB = /&lcub;/g;
const REGEX_HTML_ENTITY_RCUB = /&rcub;/g;
const CHAR_LCUB = "{";
const CHAR_RCUB = "}";
const REGEX_STRIP_HTML_TAGS = /<[^>]*>/g;
const STYLE_SEPARATOR = "; ";
function buildPositionClasses(positionX, positionY) {
  return [
    CLASS_BADGE_CORNER,
    POSITION_X_CLASS_MAP[positionX ?? DEFAULT_POSITION_X],
    POSITION_Y_CLASS_MAP[positionY ?? DEFAULT_POSITION_Y]
  ].join(" ");
}
function buildCombinedPositionClass(position) {
  if (position === POSITION_INLINE) {
    return CLASS_BADGE_INLINE;
  }
  return `${CLASS_BADGE_CORNER} ${POSITION_CLASS_MAP[position]}`;
}
function buildStyleAttr(bgColor, textColor) {
  const styles = [];
  if (bgColor) {
    styles.push(`${CSS_VAR_BADGE_BG}: ${bgColor}`);
  }
  if (textColor) {
    styles.push(`${CSS_VAR_BADGE_COLOR}: ${textColor}`);
  }
  return styles.length > 0 ? ` style="${styles.join(STYLE_SEPARATOR)}"` : "";
}
function buildBadgeHtml(config) {
  const { text, position, positionX, positionY, variant, bgColor, textColor, hidden } = config;
  if (!text?.trim() || hidden) {
    return "";
  }
  const classes = [CLASS_BADGE];
  if (position) {
    classes.push(buildCombinedPositionClass(position));
  } else if (positionX || positionY) {
    classes.push(buildPositionClasses(positionX, positionY));
  }
  if (variant && variant !== VARIANT_CUSTOM) {
    classes.push(VARIANT_CLASS_MAP[variant]);
  }
  if (hidden) {
    classes.push(CLASS_BADGE_HIDDEN);
  }
  const styleAttr = buildStyleAttr(bgColor, textColor);
  return `<span class="${classes.join(" ")}"${styleAttr} ${ATTR_DATA_BADGE}>${escapeHtml(text)}</span>`;
}
function buildDiscountBadgeHtml(showBadge, badgeText, positionX, positionY, price, comparePrice, bgColor, textColor, hideIfNoDiscount = true, frequency = "") {
  if (!showBadge) {
    return "";
  }
  const discount = calculateDiscount(price, comparePrice);
  if (hideIfNoDiscount && discount === 0) {
    return "";
  }
  const rawTemplate = badgeText?.trim() || DEFAULT_BADGE_TEXT;
  const template = rawTemplate.replace(REGEX_STRIP_HTML_TAGS, "").replace(REGEX_HTML_ENTITY_LCUB, CHAR_LCUB).replace(REGEX_HTML_ENTITY_RCUB, CHAR_RCUB);
  const text = template.replace(BADGE_PLACEHOLDER_DISCOUNT, String(discount)).replace(BADGE_PLACEHOLDER_FREQUENCY, frequency);
  return buildBadgeHtml({
    text,
    positionX: positionX ?? DEFAULT_POSITION_X,
    positionY: positionY ?? DEFAULT_POSITION_Y,
    variant: VARIANT_DISCOUNT,
    bgColor,
    textColor
  });
}
function buildPromoBadgeHtml(text, position = DEFAULT_POSITION, bgColor, textColor) {
  if (!text?.trim()) {
    return "";
  }
  return buildBadgeHtml({
    text,
    position,
    variant: VARIANT_PROMO,
    bgColor,
    textColor
  });
}
const PLACEHOLDER_FREQUENCY_ENCODED = `${ENTITY_LCUB}frequency${ENTITY_RCUB}`;
function resolveFrequencyValue(frequency, frequencyMonthly) {
  if (frequency != null && frequency !== "") {
    return frequency;
  }
  return frequencyMonthly != null ? String(frequencyMonthly) : "";
}
function replaceFrequency(text, value) {
  return text.replace(PLACEHOLDER_FREQUENCY_ENCODED, value).replace(PLACEHOLDER_FREQUENCY, value);
}
function buildUnitCostText(priceCents, unitsPerPack) {
  if (unitsPerPack <= MIN_POSITIVE_VALUE) {
    return "";
  }
  const unitCostCents = Math.floor(priceCents / unitsPerPack);
  return `${formatCentsToMoney(unitCostCents)}${SUFFIX_UNIT}`;
}
function buildMonthlyCostText(priceCents, frequencyMonthly) {
  if (frequencyMonthly <= MIN_POSITIVE_VALUE) {
    return "";
  }
  const monthlyCostCents = Math.floor(priceCents / frequencyMonthly);
  return `${formatCentsToMoney(monthlyCostCents)}${SUFFIX_MONTH}`;
}
function buildOfferButtonHtml(config) {
  const freqValue = resolveFrequencyValue(config.frequency, config.frequency_monthly);
  const title = replaceFrequency(config.title, freqValue);
  const details = config.details ? replaceFrequency(config.details, freqValue) : config.details;
  const monthlyAmount = config.monthly_amount ? replaceFrequency(config.monthly_amount, freqValue) : config.monthly_amount;
  const classes = [
    CLASS_OFFER,
    config.is_selected && CLASS_SELECTED,
    details && CLASS_HAS_DETAILS,
    config.show_additions && CLASS_HAS_ADDITIONS
  ].filter(Boolean).join(" ");
  const attrs = [
    `type="${ATTR_TYPE_BUTTON}"`,
    `class="${classes}"`,
    `${ATTR_OFFER_TYPE}="${config.offer_type}"`,
    isDefined(config.selling_plan_id) && `${ATTR_SELLING_PLAN_ID}="${config.selling_plan_id}"`,
    isDefined(config.offer_index) && `${ATTR_OFFER_INDEX}="${config.offer_index}"`,
    config.flat_variant_id && `${ATTR_FLAT_VARIANT_ID}="${config.flat_variant_id}"`,
    `role="${ATTR_ROLE_RADIO}"`,
    `${ARIA_CHECKED}="${config.is_selected}"`
  ].filter(Boolean).join(" ");
  const monthlyAmountHtml = monthlyAmount?.trim() ? `<span class="${CLASS_MONTHLY_AMOUNT}" ${ATTR_DATA_MONTHLY_AMOUNT}>${escapeHtml(monthlyAmount)}</span>` : "";
  const showPrice = config.show_price !== false;
  const priceHtml = showPrice ? `<span class="${CLASS_PRICE_CONTAINER}">
                        <span class="${CLASS_PRICE}" ${ATTR_DATA_PRICE}>${formatCentsToMoney(config.price)}</span>
                        ${isDefined(config.compare_price) && config.compare_price > config.price ? `<span class="${CLASS_COMPARE_PRICE}" ${ATTR_DATA_COMPARE_PRICE}>${formatCentsToMoney(config.compare_price)}</span>` : ""}
                    </span>` : "";
  return `
        <button ${attrs}>
            <span class="${CLASS_HEADER}">
                <span class="${CLASS_RADIO}"><span class="${CLASS_RADIO_DOT}"></span></span>
                <span class="${CLASS_CONTENT}">
                    <span class="${CLASS_TITLE}" ${ATTR_DATA_TITLE}>${escapeHtml(title)}</span>
                    ${priceHtml}
                    ${monthlyAmountHtml}
                </span>
            </span>
            ${buildDiscountBadgeHtml(config.show_badge, config.badge_text, config.badge_position_x, config.badge_position_y, config.price, config.compare_price, config.badge_bg_color, config.badge_text_color, config.hide_badge_if_no_discount, freqValue)}
            ${buildDetailsHtml(details)}
            ${buildAdditionsHtml(config.show_additions, config.additions_title, config.additions_text, config.additions_image, config.additions_image_position, config.additions_show_badge, config.additions_badge_text, config.additions_badge_position_x, config.additions_badge_position_y, config.additions_badge_bg_color, config.additions_badge_text_color)}
        </button>
    `;
}
function buildDetailsHtml(details) {
  if (!details?.trim()) {
    return "";
  }
  return `
        <span class="${CLASS_DETAILS}" ${ATTR_DATA_DETAILS}>
            <span class="${CLASS_DETAILS_CONTENT}">${details}</span>
        </span>
    `;
}
function buildOtpLinkHtml(title, price, action = ACTION_ADD_TO_CART, showPrice = true) {
  const priceSpan = showPrice ? ` <span ${ATTR_DATA_PRICE}>${formatCentsToMoney(price)}</span>` : "";
  return `<button type="${ATTR_TYPE_BUTTON}" class="${CLASS_OTP_LINK}" ${ATTR_OFFER_TYPE}="${OFFER_TYPE_OTP}" ${ATTR_ACTION}="${action}"><span ${ATTR_DATA_TITLE}>${escapeHtml(title)}</span>${priceSpan}</button>`;
}
function buildAdditionsHtml(showAdditions, additionsTitle, additionsText, additionsImage, additionsImagePosition, additionsShowBadge, additionsBadgeText, additionsBadgePositionX, additionsBadgePositionY, additionsBadgeBgColor, additionsBadgeTextColor) {
  if (!showAdditions) {
    return "";
  }
  const imagePosition = additionsImagePosition ?? DEFAULT_ADDITIONS_IMAGE_POSITION;
  const cleanBadgeText = (additionsBadgeText ?? "").replace(REGEX_HTML_TAGS, "").replace(new RegExp(ENTITY_LCUB, "g"), CHAR_LCUB$1).replace(new RegExp(ENTITY_RCUB, "g"), CHAR_RCUB$1);
  const badgeHtml = buildPromoBadgeHtml(
    cleanBadgeText,
    `${additionsBadgePositionY ?? DEFAULT_BADGE_POSITION_Y}-${additionsBadgePositionX ?? DEFAULT_BADGE_POSITION_X}`,
    additionsBadgeBgColor,
    additionsBadgeTextColor
  );
  const imageHtml = additionsImage ? `<span class="${CLASS_ADDITIONS_IMAGE}"><img ${ATTR_IMG_SRC}="${escapeHtml(additionsImage)}" ${ATTR_IMG_ALT}="${escapeHtml(additionsTitle?.replace(REGEX_HTML_TAGS, "") || "")}" ${ATTR_IMG_LOADING}="${IMG_LOADING_LAZY}" ${ATTR_IMG_WIDTH}="${ADDITIONS_IMAGE_WIDTH}" ${ATTR_IMG_HEIGHT}="${ADDITIONS_IMAGE_HEIGHT}"></span>` : "";
  const titleHtml = additionsTitle?.trim() ? `<span class="${CLASS_ADDITIONS_TITLE}">${additionsTitle}</span>` : "";
  const textHtml = additionsText?.trim() ? `<span class="${CLASS_ADDITIONS_TEXT}">${additionsText}</span>` : "";
  return `
        <span class="${CLASS_ADDITIONS} ${CLASS_ADDITIONS}${CLASS_MODIFIER_IMAGE}${imagePosition}" ${ATTR_DATA_ADDITIONS}>
            ${additionsShowBadge ? badgeHtml : ""}
            <span class="${CLASS_ADDITIONS_CONTENT}">
                ${titleHtml}
                ${textHtml}
            </span>
            ${imageHtml}
        </span>
    `;
}
const VALID_OTP_ACTIONS = /* @__PURE__ */ new Set([ACTION_ADD_TO_CART, ACTION_STRAIGHT_TO_CHECKOUT]);
class ZygOfferPicker extends Trackable(HTMLElement, { category: ANALYTICS_CATEGORY }) {
  #variantsData = null;
  #currentVariantData = null;
  #selectedOfferType = OFFER_TYPE_SELLING_PLAN;
  #selectedSellingPlanId = null;
  #selectedFlatIndex = FIRST_INDEX;
  /** Lifecycle: Initialize component when connected to DOM */
  connectedCallback() {
    this.#parseData();
    if (this.isFlatMode) {
      this.#initializeFlatMode();
      this.#renderFlatOffers();
    } else {
      this.#initializeCurrentVariant();
      this.#initializeSelectedOffer();
      if (this.#currentVariantData) {
        this.#renderOffers();
        this.#updateHasSellingPlansAttribute(this.#currentVariantData);
        this.#updateSelectedState();
      }
    }
    this.#bindEvents();
    this.#trackView();
    setTimeout(() => this.#emitOfferChange(), TIMEOUT_IMMEDIATE);
  }
  /** Lifecycle: Cleanup when removed from DOM */
  disconnectedCallback() {
    this.#unbindEvents();
  }
  /** Returns the product ID from the element attribute */
  get productId() {
    return this.getAttribute(ATTR_PRODUCT_ID) || "";
  }
  /** Returns the current variant ID from the element attribute */
  get variantId() {
    return this.getAttribute(ATTR_VARIANT_ID);
  }
  /** Returns the default selection type (subscription or otp) */
  get defaultSelection() {
    return this.getAttribute(ATTR_DEFAULT_SELECTION) || DEFAULT_SELECTION_SUBSCRIPTION;
  }
  /** Returns whether OTP should be displayed as a link instead of radio button */
  get isOtpAsLink() {
    return this.hasAttribute(ATTR_OTP_AS_LINK) || this.#variantsData?.otp_as_link === true;
  }
  /** Returns the action type for OTP link clicks (defaults to add-to-cart) */
  get otpAction() {
    return this.getAttribute(ATTR_OTP_ACTION) || ACTION_ADD_TO_CART;
  }
  /** Returns whether prices should be shown on offer cards */
  get showPrice() {
    return this.#variantsData?.show_price !== false;
  }
  /** Returns whether the picker is in flat mode (each offer can belong to a different variant) */
  get isFlatMode() {
    return this.getAttribute(ATTR_MODE) === MODE_FLAT || this.#variantsData?.mode === MODE_FLAT;
  }
  /** Returns the flat offers list (subscription entries only) */
  get flatOffers() {
    return this.#variantsData?.flat_offers ?? [];
  }
  /** Returns the variant ID whose OTP should appear in flat mode, or null */
  get flatOtpVariantId() {
    const raw = this.#variantsData?.flat_otp_variant_id;
    return raw != null ? String(raw) : null;
  }
  /** Returns the currently selected offer type */
  get selectedOfferType() {
    return this.#selectedOfferType;
  }
  /** Returns the currently selected selling plan ID (null for OTP) */
  get selectedSellingPlanId() {
    return this.#selectedSellingPlanId;
  }
  /** Returns the price of the currently selected offer */
  get selectedPrice() {
    return this.#getSelectedPriceInfo()?.price ?? 0;
  }
  /** Returns all available selling plans for the current variant */
  get sellingPlans() {
    return this.#currentVariantData?.selling_plans ?? [];
  }
  /** Returns the complementary product variant ID for the currently selected offer */
  get complementaryVariantId() {
    return this.#resolveComplementaryVariantId();
  }
  /** Returns the complementary product quantity for the currently selected offer */
  get complementaryQuantity() {
    return this.#resolveComplementaryQuantity();
  }
  /** Finds the currently selected selling plan from the variant data */
  #findSelectedSellingPlan() {
    return this.#currentVariantData?.selling_plans.find(
      (sp) => sp.id === this.#selectedSellingPlanId
    );
  }
  /** Resolves the complementary product variant ID from the selected offer's config */
  #resolveComplementaryVariantId() {
    if (!this.#variantsData) {
      return null;
    }
    if (this.#selectedOfferType === OFFER_TYPE_OTP) {
      return this.#buildMergedOtpConfig(this.#currentVariantData?.variant_index ?? 0)?.additions_product_variant_id || null;
    }
    const offerIndex = this.isFlatMode ? this.#selectedFlatIndex : this.#findSelectedOfferIndex();
    const cfg = this.#variantsData.offers[offerIndex];
    return cfg?.additions_product_variant_id || null;
  }
  /** Resolves the complementary product quantity from the selected offer's config */
  #resolveComplementaryQuantity() {
    if (!this.#variantsData) {
      return DEFAULT_COMPLEMENTARY_QUANTITY;
    }
    if (this.#selectedOfferType === OFFER_TYPE_OTP) {
      return this.#buildMergedOtpConfig(this.#currentVariantData?.variant_index ?? 0)?.additions_product_quantity ?? DEFAULT_COMPLEMENTARY_QUANTITY;
    }
    const offerIndex = this.isFlatMode ? this.#selectedFlatIndex : this.#findSelectedOfferIndex();
    return this.#variantsData.offers[offerIndex]?.additions_product_quantity ?? DEFAULT_COMPLEMENTARY_QUANTITY;
  }
  /** Returns the index of the selected selling plan within the current variant's plans */
  #findSelectedOfferIndex() {
    if (!this.#currentVariantData || this.#selectedSellingPlanId == null) {
      return FIRST_INDEX;
    }
    const index = this.#currentVariantData.selling_plans.findIndex(
      (sp) => sp.id === this.#selectedSellingPlanId
    );
    return index >= 0 ? index : FIRST_INDEX;
  }
  /** Returns variant and data if both exist, otherwise null */
  #getVariantAndData() {
    return this.#currentVariantData && this.#variantsData ? { variant: this.#currentVariantData, data: this.#variantsData } : null;
  }
  /** Returns the resolved OTP config for a variant (global defaults merged with per-variant overrides) */
  #buildMergedOtpConfig(variantIndex) {
    if (!this.#variantsData) {
      return null;
    }
    const defaults = this.#variantsData.otp_defaults;
    const override = this.#variantsData.otp_variant_configs?.[variantIndex];
    if (!override) {
      return defaults;
    }
    return mergeConfigOverrides(defaults, override);
  }
  /** Public API: Programmatically select an offer */
  selectOffer(offerType, sellingPlanId) {
    if (offerType === OFFER_TYPE_OTP) {
      this.#doSelectOffer(OFFER_TYPE_OTP, null);
    } else if (offerType === OFFER_TYPE_SELLING_PLAN && isDefined(sellingPlanId)) {
      this.#doSelectOffer(OFFER_TYPE_SELLING_PLAN, sellingPlanId);
    }
  }
  /** Public API: Returns a copy of the current variant's offer data */
  getCurrentVariantData() {
    return this.#currentVariantData ? { ...this.#currentVariantData } : null;
  }
  /** Public API: Returns a copy of all variants' offer data */
  getVariantsData() {
    return this.#variantsData ? { ...this.#variantsData } : null;
  }
  /** Public API: Adds the OTP variant to cart */
  async addOtpToCart() {
    await this.#executeAddToCart(true);
  }
  /** Parses JSON data from embedded script element */
  #parseData() {
    const dataScript = this.querySelector(SELECTOR_VARIANTS_OFFERS_DATA);
    if (!dataScript) {
      return;
    }
    try {
      this.#variantsData = JSON.parse(dataScript.textContent || "");
    } catch {
      console.error(ERROR_PARSE_DATA);
      this.#variantsData = null;
    }
  }
  /** Sets the current variant data, syncing with variant picker if present */
  #initializeCurrentVariant() {
    const resolvedVariantId = this.#resolveInitialVariantId() ?? this.variantId;
    if (resolvedVariantId && this.#variantsData?.variants[resolvedVariantId]) {
      this.setAttribute(ATTR_VARIANT_ID, resolvedVariantId);
      this.#currentVariantData = this.#variantsData.variants[resolvedVariantId];
    }
  }
  /** Checks for a sibling variant picker and returns its selected variant ID */
  #resolveInitialVariantId() {
    const variantPicker = document.querySelector(
      `${VARIANT_PICKER_ELEMENT}[${ATTR_PRODUCT_ID}="${this.productId}"]`
    );
    const pickerVariantId = variantPicker?.getAttribute(ATTR_VARIANT_ID);
    if (pickerVariantId && this.#variantsData?.variants[pickerVariantId]) {
      return pickerVariantId;
    }
    return null;
  }
  /** Sets the initial selected offer based on default selection and availability */
  #initializeSelectedOffer() {
    const sellingPlans = this.#currentVariantData?.selling_plans ?? [];
    if (sellingPlans.length === 0) {
      this.#selectedOfferType = OFFER_TYPE_OTP;
      this.#selectedSellingPlanId = null;
      return;
    }
    const resolvedPlanId = this.#resolveDefaultSellingPlanId(sellingPlans);
    this.#selectedOfferType = isDefined(resolvedPlanId) ? OFFER_TYPE_SELLING_PLAN : OFFER_TYPE_OTP;
    this.#selectedSellingPlanId = resolvedPlanId;
  }
  /** Resolves the default selling plan ID based on selection setting */
  #resolveDefaultSellingPlanId(sellingPlans) {
    const selection = this.defaultSelection;
    if (selection === DEFAULT_SELECTION_OTP) {
      return null;
    }
    const firstPlanId = sellingPlans[FIRST_INDEX].id;
    if (selection.startsWith(DEFAULT_SELECTION_OFFER_PREFIX)) {
      const index = parseInt(selection.slice(DEFAULT_SELECTION_OFFER_PREFIX.length), RADIX_DECIMAL) - ONE_BASED_INDEX_OFFSET;
      return sellingPlans[index]?.id ?? firstPlanId;
    }
    return firstPlanId;
  }
  /** Attaches click and variant change event listeners */
  #bindEvents() {
    this.addEventListener(EVENT_CLICK, this.#handleClick);
    if (!this.isFlatMode) {
      document.addEventListener(DOM_EVENT_VARIANT_CHANGE, this.#handleVariantChange);
    }
  }
  /** Removes event listeners on disconnect */
  #unbindEvents() {
    this.removeEventListener(EVENT_CLICK, this.#handleClick);
    if (!this.isFlatMode) {
      document.removeEventListener(DOM_EVENT_VARIANT_CHANGE, this.#handleVariantChange);
    }
  }
  /** Handles click events and delegates to appropriate handler */
  #handleClick = (event) => {
    const target = event.target;
    const otpLink = target.closest(SELECTOR_OTP_LINK);
    if (otpLink) {
      this.#handleOtpLinkClick(otpLink);
      return;
    }
    const offerButton = target.closest(SELECTOR_OFFER);
    if (offerButton) {
      this.#handleOfferButtonClick(offerButton);
    }
  };
  /** Handles OTP link click - sets flat variant if needed, then triggers the configured action */
  #handleOtpLinkClick(otpLink) {
    const action = otpLink.getAttribute(ATTR_ACTION);
    if (!action || !VALID_OTP_ACTIONS.has(action)) {
      return;
    }
    if (this.isFlatMode && this.flatOtpVariantId) {
      this.setAttribute(ATTR_VARIANT_ID, this.flatOtpVariantId);
    }
    if (action === ACTION_ADD_TO_CART) {
      this.#executeAddToCart(true);
      return;
    }
    void this.#executeCheckoutFlow(true);
  }
  /** Handles offer button click - updates selection state */
  #handleOfferButtonClick(offerButton) {
    const offerType = offerButton.getAttribute(ATTR_OFFER_TYPE);
    const planId = offerType === OFFER_TYPE_SELLING_PLAN ? parseInt(offerButton.getAttribute(ATTR_SELLING_PLAN_ID) ?? "", RADIX_DECIMAL) || null : null;
    if (this.isFlatMode) {
      const flatVariantId = offerButton.getAttribute(ATTR_FLAT_VARIANT_ID);
      this.#doSelectFlatOffer(offerType, planId, flatVariantId);
      return;
    }
    if (!this.#isOfferSelected(offerType, planId ? String(planId) : null)) {
      this.#doSelectOffer(offerType, planId);
    }
  }
  /** Handles variant change events from variant picker */
  #handleVariantChange = (event) => {
    const { variant, productId } = event.detail || {
      variant: void 0,
      productId: void 0
    };
    if (!variant || productId !== this.productId) {
      return;
    }
    this.#updateFromVariant(variant);
  };
  /** Updates component state when variant changes */
  #updateFromVariant(variant) {
    const variantId = String(variant.id);
    this.setAttribute(ATTR_VARIANT_ID, variantId);
    const newVariantData = this.#variantsData?.variants[variantId];
    if (!newVariantData) {
      return;
    }
    this.#currentVariantData = newVariantData;
    this.#renderOffers();
    this.#updateHasSellingPlansAttribute(newVariantData);
    this.#updateSelectionForNewVariant(newVariantData);
    this.#updateSelectedState();
    this.#emitOfferChange();
  }
  /** Updates data attribute indicating if variant has selling plans */
  #updateHasSellingPlansAttribute(variantData) {
    this.toggleAttribute(ATTR_HAS_SELLING_PLANS, variantData.selling_plans.length > 0);
  }
  /** Adjusts selection when switching to a variant with different selling plans */
  #updateSelectionForNewVariant(variantData) {
    if (this.#selectedOfferType !== OFFER_TYPE_SELLING_PLAN) {
      return;
    }
    const plans = variantData.selling_plans;
    const currentPlanExists = plans.some((sp) => sp.id === this.#selectedSellingPlanId);
    this.#selectedOfferType = plans.length > 0 ? OFFER_TYPE_SELLING_PLAN : OFFER_TYPE_OTP;
    this.#selectedSellingPlanId = plans.length > 0 ? currentPlanExists ? this.#selectedSellingPlanId : plans[0].id : null;
  }
  /** Performs offer selection and triggers side effects */
  #doSelectOffer(offerType, sellingPlanId) {
    this.#selectedOfferType = offerType;
    this.#selectedSellingPlanId = sellingPlanId;
    this.#updateSelectedState();
    this.#emitOfferChange();
    this.#trackSelect();
  }
  /** Updates visual selected state of all offer buttons */
  #updateSelectedState() {
    this.querySelectorAll(SELECTOR_OFFER).forEach((offer) => {
      const offerType = offer.getAttribute(ATTR_OFFER_TYPE);
      const sellingPlanId = offer.getAttribute(ATTR_SELLING_PLAN_ID);
      const isSelected = this.isFlatMode ? this.#isFlatOfferSelected(
        offerType,
        sellingPlanId,
        offer.getAttribute(ATTR_FLAT_VARIANT_ID)
      ) : this.#isOfferSelected(offerType, sellingPlanId);
      offer.classList.toggle(CLASS_SELECTED, isSelected);
      offer.setAttribute(ARIA_CHECKED, String(isSelected));
    });
  }
  /** Determines if a specific offer is currently selected */
  #isOfferSelected(offerType, sellingPlanId) {
    switch (offerType) {
      case OFFER_TYPE_OTP:
        return this.#selectedOfferType === OFFER_TYPE_OTP;
      case OFFER_TYPE_SELLING_PLAN:
        return this.#selectedOfferType === OFFER_TYPE_SELLING_PLAN && isDefined(sellingPlanId) && parseInt(sellingPlanId, RADIX_DECIMAL) === this.#selectedSellingPlanId;
    }
  }
  /** Executes add to cart flow with error handling */
  async #executeAddToCart(forceOtp = false) {
    const variantId = this.variantId;
    if (!variantId) {
      console.error(ERROR_MISSING_VARIANT_ID);
      return;
    }
    try {
      await this.#addToCart(variantId, forceOtp);
      this.#onAddToCartSuccess(variantId, forceOtp);
    } catch (error) {
      console.error(ERROR_ADD_TO_CART_FAILED, error);
    }
  }
  /** Executes checkout flow: optionally clears cart, adds item, skips drawer, redirects */
  async #executeCheckoutFlow(clearFirst) {
    const variantId = this.variantId;
    if (!variantId) {
      console.error(ERROR_MISSING_VARIANT_ID);
      return;
    }
    try {
      const cartApi = await whenCartReady();
      if (clearFirst) {
        await cartApi.clear();
      }
      await this.#addToCart(variantId, true);
      this.#onCheckoutSuccess(variantId);
      window.location.href = CHECKOUT_URL;
    } catch (error) {
      console.error(ERROR_ADD_TO_CART_FAILED, error);
    }
  }
  /** Adds variant to cart via window.cart or fetch fallback */
  async #addToCart(variantId, forceOtp = false) {
    const isSubscription = !forceOtp && this.#selectedOfferType === OFFER_TYPE_SELLING_PLAN;
    const sellingPlanId = isSubscription ? this.#selectedSellingPlanId : null;
    const otpCfg = forceOtp ? this.#buildMergedOtpConfig(this.#currentVariantData?.variant_index ?? 0) : null;
    const complementaryId = forceOtp ? otpCfg?.additions_product_variant_id || null : this.#resolveComplementaryVariantId();
    const complementaryQty = forceOtp ? otpCfg?.additions_product_quantity ?? DEFAULT_COMPLEMENTARY_QUANTITY : this.#resolveComplementaryQuantity();
    const cartApi = await whenCartReady();
    await cartApi.addWithComplementary(
      {
        id: variantId,
        quantity: DEFAULT_QUANTITY,
        source: SOURCE_OFFER_PICKER,
        initialOffer: isSubscription ? OFFER_TYPE.SUBSCRIPTION : OFFER_TYPE.ONE_TIME,
        sellingPlan: sellingPlanId ? String(sellingPlanId) : void 0
      },
      complementaryId,
      complementaryQty
    );
  }
  /** Dispatches cart add event (triggers cart drawer open) and tracks analytics */
  #onAddToCartSuccess(variantId, forceOtp = false) {
    document.dispatchEvent(
      new CustomEvent(DOM_EVENT_CART_ADD, {
        bubbles: true,
        detail: {
          data: {
            source: EVENT_SOURCE_PRODUCT_FORM
          }
        }
      })
    );
    const offerType = forceOtp ? OFFER_TYPE_OTP : this.#selectedOfferType;
    this.track(ANALYTICS_ACTION_SELECT, {
      offer_type: offerType,
      action: ACTION_ADD_TO_CART,
      variant_id: variantId
    });
  }
  /** Dispatches cart add event with skipDrawer (for checkout flows) and tracks analytics */
  #onCheckoutSuccess(variantId) {
    document.dispatchEvent(
      new CustomEvent(DOM_EVENT_CART_ADD, {
        bubbles: true,
        detail: {
          data: {
            source: EVENT_SOURCE_PRODUCT_FORM,
            skipDrawer: true
          }
        }
      })
    );
    this.track(ANALYTICS_ACTION_SELECT, {
      offer_type: OFFER_TYPE_OTP,
      action: ACTION_STRAIGHT_TO_CHECKOUT,
      variant_id: variantId
    });
  }
  /** Re-renders all offer buttons when variant changes */
  #renderOffers() {
    if (this.isFlatMode) {
      this.#renderFlatOffers();
      return;
    }
    if (!this.#currentVariantData || !this.#variantsData) {
      return;
    }
    const container = this.querySelector(SELECTOR_CONTAINER);
    if (!container) {
      return;
    }
    const otpHtml = this.#buildOtpHtml();
    const sellingPlansHtml = this.#buildSellingPlansHtml();
    if (this.isOtpAsLink) {
      container.innerHTML = sellingPlansHtml + otpHtml;
    } else {
      container.innerHTML = this.#variantsData.otp_position === OTP_POSITION_TOP ? otpHtml + sellingPlansHtml : sellingPlansHtml + otpHtml;
    }
  }
  /** Builds HTML for one-time purchase option */
  #buildOtpHtml() {
    const ctx = this.#getVariantAndData();
    if (!ctx) {
      return "";
    }
    const { variant, data } = ctx;
    const cfg = this.#buildMergedOtpConfig(variant.variant_index);
    if (!cfg) {
      return "";
    }
    if (this.isOtpAsLink) {
      return buildOtpLinkHtml(cfg.title, variant.price, this.otpAction);
    }
    const otpDiscount = calculateDiscount(variant.price, variant.compare_at_price);
    const shouldShowOtpBadge = cfg.show_badge && (!cfg.hide_badge_if_no_discount || otpDiscount > MIN_POSITIVE_VALUE);
    const unitCostText = data.otp_show_unit_cost && !variant.is_first_variant && variant.units_per_pack ? buildUnitCostText(variant.price, variant.units_per_pack) : "";
    return buildOfferButtonHtml({
      ...cfg,
      offer_type: OFFER_TYPE_OTP,
      price: variant.price,
      compare_price: variant.compare_at_price,
      is_selected: this.#selectedOfferType === OFFER_TYPE_OTP,
      show_badge: shouldShowOtpBadge,
      monthly_amount: unitCostText,
      frequency_monthly: variant.frequency_monthly,
      frequency: variant.frequency
    });
  }
  /** Builds HTML for all selling plan options */
  #buildSellingPlansHtml() {
    const ctx = this.#getVariantAndData();
    if (!ctx) {
      return "";
    }
    const { variant, data } = ctx;
    return variant.selling_plans.slice(FIRST_INDEX, data.max_selling_plans).map((plan, index) => {
      const cfg = data.offers[index];
      const isSelected = this.#selectedOfferType === OFFER_TYPE_SELLING_PLAN && (this.#selectedSellingPlanId === plan.id || !isDefined(this.#selectedSellingPlanId) && index === FIRST_INDEX);
      const basePrice = variant.compare_at_price || variant.price;
      const calculatedMonthlyAmount = cfg?.show_monthly_amount && variant.frequency_monthly ? buildMonthlyCostText(plan.price, variant.frequency_monthly) : "";
      const displayMonthlyAmount = cfg?.monthly_amount || calculatedMonthlyAmount;
      return buildOfferButtonHtml({
        ...cfg,
        offer_type: OFFER_TYPE_SELLING_PLAN,
        selling_plan_id: plan.id,
        offer_index: index,
        title: cfg?.title || plan.name,
        price: plan.price,
        compare_price: basePrice > plan.price ? basePrice : null,
        is_selected: isSelected,
        monthly_amount: displayMonthlyAmount,
        details: cfg?.details ?? "",
        frequency_monthly: variant.frequency_monthly,
        frequency: variant.frequency
      });
    }).join("");
  }
  /** Initializes flat mode by selecting the default offer and setting variant context */
  #initializeFlatMode() {
    const entries = this.flatOffers;
    const hasSelectableOtp = !!this.flatOtpVariantId && !this.isOtpAsLink;
    if (entries.length === 0 && !hasSelectableOtp) {
      return;
    }
    if (this.defaultSelection === DEFAULT_SELECTION_OTP && hasSelectableOtp) {
      this.#initializeFlatOtp();
      return;
    }
    if (entries.length === 0) {
      if (hasSelectableOtp) {
        this.#initializeFlatOtp();
      }
      return;
    }
    const defaultIndex = this.#resolveFlatDefaultIndex(entries);
    this.#selectedFlatIndex = defaultIndex;
    const entry = entries[defaultIndex];
    const variantData = this.#variantsData?.variants[entry.variant_id];
    if (!variantData) {
      return;
    }
    this.#currentVariantData = variantData;
    this.setAttribute(ATTR_VARIANT_ID, entry.variant_id);
    const planIndex = entry.selling_plan_index;
    const plan = variantData.selling_plans[planIndex];
    this.#selectedOfferType = OFFER_TYPE_SELLING_PLAN;
    this.#selectedSellingPlanId = plan?.id ?? null;
  }
  /** Initializes flat mode with OTP selected as the default */
  #initializeFlatOtp() {
    const otpVariantId = this.flatOtpVariantId;
    if (!otpVariantId) {
      return;
    }
    const variantData = this.#variantsData?.variants[otpVariantId];
    if (!variantData) {
      return;
    }
    this.#selectedFlatIndex = FLAT_OTP_INDEX;
    this.#selectedOfferType = OFFER_TYPE_OTP;
    this.#selectedSellingPlanId = null;
    this.#currentVariantData = variantData;
    this.setAttribute(ATTR_VARIANT_ID, otpVariantId);
  }
  /** Resolves which flat subscription offer to select by default based on default_selection */
  #resolveFlatDefaultIndex(entries) {
    const selection = this.defaultSelection;
    if (selection.startsWith(DEFAULT_SELECTION_OFFER_PREFIX)) {
      const offerNum = parseInt(selection.slice(DEFAULT_SELECTION_OFFER_PREFIX.length), RADIX_DECIMAL) - ONE_BASED_INDEX_OFFSET;
      return offerNum >= 0 && offerNum < entries.length ? offerNum : FIRST_INDEX;
    }
    return FIRST_INDEX;
  }
  /** Selects a flat offer by type, selling plan, and variant, then emits events */
  #doSelectFlatOffer(offerType, sellingPlanId, flatVariantId) {
    if (!flatVariantId || !this.#variantsData) {
      return;
    }
    const newIndex = this.#resolveFlatClickIndex(offerType, sellingPlanId, flatVariantId);
    if (newIndex == null || newIndex === this.#selectedFlatIndex) {
      return;
    }
    this.#selectedFlatIndex = newIndex;
    this.#selectedOfferType = offerType;
    this.#selectedSellingPlanId = sellingPlanId;
    const variantData = this.#variantsData.variants[flatVariantId];
    if (variantData) {
      this.#currentVariantData = variantData;
      this.setAttribute(ATTR_VARIANT_ID, flatVariantId);
    }
    this.#updateSelectedState();
    this.#emitOfferChange();
    this.#trackSelect();
  }
  /** Resolves the flat offer index for a click, or null if the click is invalid */
  #resolveFlatClickIndex(offerType, sellingPlanId, flatVariantId) {
    if (offerType === OFFER_TYPE_OTP) {
      return flatVariantId === this.flatOtpVariantId ? FLAT_OTP_INDEX : null;
    }
    const variantsData = this.#variantsData;
    const index = this.flatOffers.findIndex((entry) => {
      if (entry.variant_id !== flatVariantId) {
        return false;
      }
      const plan = variantsData?.variants[entry.variant_id]?.selling_plans[entry.selling_plan_index];
      return plan?.id === sellingPlanId;
    });
    return index >= 0 ? index : null;
  }
  /** Renders all flat offer buttons (subscriptions + optional OTP) */
  #renderFlatOffers() {
    if (!this.#variantsData) {
      return;
    }
    const container = this.querySelector(SELECTOR_CONTAINER);
    if (!container) {
      return;
    }
    const subscriptionHtml = this.flatOffers.map((entry, index) => this.#buildFlatOfferHtml(entry, index)).join("");
    const otpHtml = this.#buildFlatOtpHtml();
    container.innerHTML = this.#variantsData.otp_position === OTP_POSITION_TOP ? otpHtml + subscriptionHtml : subscriptionHtml + otpHtml;
  }
  /** Builds HTML for a single flat subscription offer entry */
  #buildFlatOfferHtml(entry, index) {
    const variantData = this.#variantsData?.variants[entry.variant_id];
    if (!variantData) {
      return "";
    }
    const isSelected = index === this.#selectedFlatIndex;
    const cfg = this.#variantsData?.offers[index];
    const planIndex = entry.selling_plan_index;
    const plan = variantData.selling_plans[planIndex];
    if (!plan) {
      return "";
    }
    const basePrice = variantData.compare_at_price || variantData.price;
    const calculatedMonthlyAmount = cfg?.show_monthly_amount && variantData.frequency_monthly ? buildMonthlyCostText(plan.price, variantData.frequency_monthly) : "";
    const displayMonthlyAmount = cfg?.monthly_amount || calculatedMonthlyAmount;
    return buildOfferButtonHtml({
      ...cfg,
      offer_type: OFFER_TYPE_SELLING_PLAN,
      selling_plan_id: plan.id,
      flat_variant_id: entry.variant_id,
      offer_index: index,
      title: cfg?.title || plan.name,
      price: plan.price,
      compare_price: basePrice > plan.price ? basePrice : null,
      is_selected: isSelected,
      monthly_amount: displayMonthlyAmount,
      details: cfg?.details ?? "",
      frequency_monthly: variantData.frequency_monthly,
      frequency: variantData.frequency
    });
  }
  /** Builds HTML for the OTP button in flat mode using flat_otp_variant_id */
  #buildFlatOtpHtml() {
    const otpVariantId = this.flatOtpVariantId;
    if (!otpVariantId || !this.#variantsData) {
      return "";
    }
    const variantData = this.#variantsData.variants[otpVariantId];
    if (!variantData) {
      return "";
    }
    const cfg = this.#buildMergedOtpConfig(variantData.variant_index);
    if (!cfg) {
      return "";
    }
    if (this.isOtpAsLink) {
      return buildOtpLinkHtml(cfg.title, variantData.price, this.otpAction);
    }
    const otpDiscount = calculateDiscount(variantData.price, variantData.compare_at_price);
    const shouldShowOtpBadge = cfg.show_badge && (!cfg.hide_badge_if_no_discount || otpDiscount > MIN_POSITIVE_VALUE);
    return buildOfferButtonHtml({
      ...cfg,
      offer_type: OFFER_TYPE_OTP,
      flat_variant_id: otpVariantId,
      price: variantData.price,
      compare_price: variantData.compare_at_price,
      is_selected: this.#selectedFlatIndex === FLAT_OTP_INDEX,
      show_badge: shouldShowOtpBadge,
      frequency_monthly: variantData.frequency_monthly,
      frequency: variantData.frequency
    });
  }
  /** Checks if a flat offer button is the currently selected one */
  #isFlatOfferSelected(offerType, sellingPlanId, flatVariantId) {
    if (offerType === OFFER_TYPE_OTP) {
      return this.#selectedFlatIndex === FLAT_OTP_INDEX && flatVariantId === this.flatOtpVariantId;
    }
    const entry = this.flatOffers[this.#selectedFlatIndex];
    if (!entry || entry.variant_id !== flatVariantId) {
      return false;
    }
    const plan = this.#variantsData?.variants[entry.variant_id]?.selling_plans[entry.selling_plan_index];
    return isDefined(sellingPlanId) && plan?.id === parseInt(sellingPlanId, RADIX_DECIMAL);
  }
  /** Dispatches offer change events for external listeners */
  #emitOfferChange() {
    if (!this.#currentVariantData) {
      return;
    }
    const detail = this.#buildOfferChangeDetail();
    document.dispatchEvent(new CustomEvent(DOM_EVENT_OFFER_CHANGE, { bubbles: true, detail }));
    this.dispatchEvent(
      new CustomEvent(DOM_EVENT_LOCAL_OFFER_CHANGE, { bubbles: true, detail })
    );
  }
  /** Builds the detail object for offer change events */
  #buildOfferChangeDetail() {
    const { price, compareAtPrice } = this.#getSelectedPriceInfo();
    return {
      offerType: this.#selectedOfferType,
      sellingPlanId: this.#selectedSellingPlanId,
      price,
      compareAtPrice,
      productId: this.productId,
      variantId: this.variantId,
      complementaryVariantId: this.#resolveComplementaryVariantId(),
      complementaryQuantity: this.#resolveComplementaryQuantity()
    };
  }
  /** Returns price info for the currently selected offer */
  #getSelectedPriceInfo() {
    if (!this.#currentVariantData) {
      return { price: 0, compareAtPrice: null };
    }
    switch (this.#selectedOfferType) {
      case OFFER_TYPE_OTP:
        return {
          price: this.#currentVariantData.price,
          compareAtPrice: this.#currentVariantData.compare_at_price
        };
      case OFFER_TYPE_SELLING_PLAN: {
        const sellingPlan = this.#findSelectedSellingPlan();
        return sellingPlan ? { price: sellingPlan.price, compareAtPrice: sellingPlan.compare_at_price } : { price: 0, compareAtPrice: null };
      }
    }
  }
  /** Tracks component view for analytics */
  #trackView() {
    this.track(ANALYTICS_ACTION_VIEW, {
      productId: this.productId,
      defaultSelection: this.defaultSelection,
      sellingPlansCount: this.#currentVariantData?.selling_plans.length ?? 0
    });
  }
  /** Tracks offer selection for analytics */
  #trackSelect() {
    this.track(ANALYTICS_ACTION_SELECT, {
      productId: this.productId,
      offerType: this.#selectedOfferType,
      sellingPlanId: this.#selectedSellingPlanId,
      offerName: this.#getSelectedOfferName(),
      price: this.selectedPrice
    });
  }
  /** Returns the display name of the currently selected offer */
  #getSelectedOfferName() {
    if (this.#selectedOfferType === OFFER_TYPE_OTP) {
      return this.#buildMergedOtpConfig(this.#currentVariantData?.variant_index ?? 0)?.title || DEFAULT_OTP_TITLE;
    }
    return this.#findSelectedSellingPlan()?.name ?? DEFAULT_SELLING_PLAN_NAME;
  }
}
if (!customElements.get(ELEMENT_NAME)) {
  customElements.define(ELEMENT_NAME, ZygOfferPicker);
}
